
export class TCNXSocieteUser {
  public static TableName: string = "REL_tPASoc_tUSUse";
}
export class TCNXHisto {
  public static TableName: string = "tUSHisto";
}
export class TCNXSociete {
  public static TableName: string = "tPASociete";
}
export class TBOListe {
  public static TableName: string = "tBOListe";
}
export class TBOProperty {
  public static TableName: string = "tBOProperty";
}
export class TBOValue {
  public static TableName: string = "tBOValue";
}
export class TDOPeres {
  public static TableName: string = "tDOPeres";
}
export class TPAStock {
  public static TableName: string = "tPAStock";
}
export class TDOSalaire {
  public static TableName: string = "tDOSalaire";
}
export class TDOFicheTech {
  public static TableName: string = "tDOFicheTech";
}
export class TDOFiche {
  public static TableName: string = "tDOFiche";
}
export class TDOLicence {
  public static TableName: string = "tDOLiscence";
}
export class TTODisplay {
  public static TableName: string = "tTODisplay";
}
export class TDOLien {
  public static TableName: string = "tDOLien";
}
export class TPALienInfo {
  public static TableName: string = "tPALienInfo";
}
export class TPAProduit {
  public static TableName: string = "tPAProduit";
}
export class TPACategorie {
  public static TableName: string = "tPACategorie";
}
export class TDORelation {
  public static TableName: string = "tDORelation";
}
export class TDOEvenement {
  public static TableName: string = "TDOEvenement";
}
export class TDODossier {
  public static TableName: string = "tDODossier";
}
export class TDOCatalogue {
  public static TableName: string = "tDOCatalogue";
}
export class TDOConnaissance {
  public static TableName: string = "tDOConnaissance";
}
export class TDOChapitre {
  public static TableName: string = "tDOChapitre";
}
export class TDOCatalogueEL {
  public static TableName: string = "tDOCatalogueEL";
}
export class TPACycle {
  public static TableName: string = "tPACycle";
}
export class TDOCycleEL {
  public static TableName: string = "tDOCycleEL";
}
export class TDOAvancementEL {
  public static TableName: string = "tDOAvancementEL";
}
export class TDOHistoriqueEL {
  public static TableName: string = "tDOHistoriqueEL";
}
export class TQUModelQuestionnaire {
  public static TableName: string = "tQUModelQuestionnaire";
}
export class TQUModelQuestion {
  public static TableName: string = "tQUModelQuestion";
}
export class TQUModelReponse {
  public static TableName: string = "tQUModelReponse";
}
export class TQUReponse {
  public static TableName: string = "tQUReponse";
}
export class TQUQuestionnaire {
  public static TableName: string = "tQUQuestionnaire";
}
export class TDODocument {
  public static TableName: string = "tDODocument";
}
export class TDOPrestation {
  public static TableName: string = "tDOPrestation";
}
export class TDOInfosFiscalAGACGA {
  public static TableName: string = "tDOInfoFiscale";
}
export class TDOFicheTemps {
  public static TableName: string = "TDOFicheTemps";
}
export class TDOClient {
  public static TableName: string = "tDOClient";
}
export class TDOMillesime {
  public static TableName: string = "tDOMillesime";
}
export class TDOProduction {
  public static TableName: string = "tDOProduction";
}
export class TDOPersonne {
  public static TableName: string = "tDOPersonne";
}
export class TDOObjectif {
  public static TableName: string = "tDOObjectif";
}
export class TDOObjet {
  public static TableName: string = "tDOObjet";
}
export class tUSGroupe {
  public static TableName: string = "tUSGroupe";
}
export class TDOAction {
  public static TableName: string = "tDOAction";
}
export class TDOEntretien {
  public static TableName: string = "tDOEntretien";
}
export class TDOGroupeSociete {
  public static TableName: string = "tDOGroupeSociete";
}
export class TDOHistoTache {
  public static TableName: string = "tDOHistoTache";
}
export class TDOHistorique {
  public static TableName: string = "tDOHistorique";
}
export class TDODevis {
  public static TableName: string = "tDODevis";
}
export class TDOEtablissement {
  public static TableName: string = "tDOEtablissement";
}
export class TDODebours {
  public static TableName: string = "tDODebours";
}
export class TDODepense {
  public static TableName: string = "tDODepense";
}
export class TDOModeFacturation {
  public static TableName: string = "tDOModeFacturation";
}
export class tDONoteDeFrais {
  public static TableName: string = "tDONoteF";
}
export class TDOBrouillard {
  public static TableName: string = "tDOBrouillard";
}
export class TDORib {
  public static TableName: string = "tDORib";
}
export class TDOService {
  public static TableName: string = "tDOService";
}
export class TDOReglement {
  public static TableName: string = "tDOReglement";
}
export class TDOTemps {
  public static TableName: string = "tDOTemps";
}
export class TDOOption {
  public static TableName: string = "TDOOption";
}
export class TDOAdresse {
  public static TableName: string = "tDOAdresse";
}
export class TDOTarification {
  public static TableName: string = "tDOTarification";
}
export class TDOPlanDeCharge {
  public static TableName: string = "tDOPlanDeCharge";
}
export class TDOFamille {
  public static TableName: string = "tDOFamille";
}
export class TDOChambre {
  public static TableName: string = "tDOChambre";
}
export class tDOObligation {
  public static TableName: string = "tDOObligation";
}
export class tDOHistoControle {
  public static TableName: string = "tDOHistoControle";
}
export class tDOGuident {
  public static TableName: string = "tDOGuident";
}
export class tDOMedia {
  public static TableName: string = "tDOMedia";
}
export class tDOStatGroupe {
  public static TableName: string = "tDOStatGroupe";
}
export class tDOStatLigne {
  public static TableName: string = "tDOStatLigne";
}
export class tDOStatistique {
  public static TableName: string = "tDOStatistique";
}
export class TDOTag {
  public static TableName: string = "tDOTag";
}
export class TUser {
  public static TableName: string = "dbo.tUSUser";
}
export class TPAGRAPHIQUE {
  public static TableName: string = "TPAGraphique";
}
export class TPAPrix {
  public static TableName: string = "tPAPrix";
}
export class TPAApe {
  public static TableName: string = "tPAApe";
}
export class TPAModele {
  public static TableName: string = "TPAModele";
}
export class TPAApplication {
  public static TableName: string = "TPAApplication";
}
export class TPABareme {
  public static TableName: string = "tPABareme";
}
export class TPAColumn {
  public static TableName: string = "tPAColumn";
}
export class TPADossier {
  public static TableName: string = "tPADossier";
}
export class TPAIdentUnique {
  public static TableName: string = "TPAIdentUnique";
}
export class TPAInsee {
  public static TableName: string = "tPAInsee";
}
export class TPANoti {
  public static TableName: string = "tPANotification";
}
export class TPANumering {
  public static TableName: string = "tPANumering";
}
export class TPAPlanFactureResultat {
  public static TableName: string = "tPAPlanFactCompte";
}
export class TPAPlanFacture {
  public static TableName: string = "tPAPlanFacture";
}
export class TPAArticleFact {
  public static TableName: string = "tPAArticleFact";
}
export class tPAParndf {
  public static TableName: string = "tPAParndf";
}
export class tPAInfoNDF {
  public static TableName: string = "tPAInfoNDF";
}
export class TPAProcedure {
  public static TableName: string = "tPAProcedure";
}
export class TPAService {
  public static TableName: string = "tPAService";
}
export class TPATable {
  public static TableName: string = "tPATable";
}
export class TTempsPasse {
  public static TableName: string = "tPATempsPasse";
}
export class TPAWorkFlo {
  public static TableName: string = "tPAWorkFlo";
}
export class TAffiche {
  public static TableName: string = "tUSAffiche";
}
export class TUSAlerte {
  public static TableName: string = "tUSAlerte";
}
export class TBlock {
  public static TableName: string = "tUSBlock";
}
export class TBrick {
  public static TableName: string = "tUSBrick";
}
export class TConteneur {
  public static TableName: string = "tUSConteneur";
}
export class TUSFiltre {
  public static TableName: string = "tUSFiltre";
}
export class TGroupe {
  public static TableName: string = "tUSGroupe";
}
export class TLanceur {
  public static TableName: string = "tUSLanceur";
}
export class TUSNoti {
  public static TableName: string = "tUSNotification";
}
export class TPortail {
  public static TableName: string = "tUSPortail";
}
export class TTreeview {
  public static TableName: string = "tUSTreeview";
}
export class TPAGroupe {
  public static TableName: string = "tPAGroupe";
}
export class TPATraduction {
  public static TableName: string = "tPATraduction";
}
export class TPACorrespondance {
  public static TableName: string = "tPACorrespondance";
}
export class TCODossier {
  public static TableName: string = "tCODossier";
}
export class TCOCompte {
  public static TableName: string = "tCOCompte";
}
export class TCOJournal {
  public static TableName: string = "tCOJournal";
}
export class TCOCopilote {
  public static TableName: string = "tCOCoPilote";
}
export class TCOExercice {
  public static TableName: string = "tCOExercice";
}
export class TCOEcriture {
  public static TableName: string = "tCOEcriture";
}
export class TCOProfil {
  public static TableName: string = "tCOProfil";
}
export class TCOPIECE {
  public static TableName: string = "tCOPiece";
}
export class TCOTRESORERIE {
  public static TableName: string = "tCOTresorerie";
}
export class TCOAVDR {
  public static TableName: string = "tCOAVDR";
}
export class TCOBanque {
  public static TableName: string = "tCOBanque";
}
export class TCOProduit {
  public static TableName: string = "tCOProduit";
}
export class tCOParamRH {
  public static TableName: string = "tCOParamRH";
}
export class tCORHpaye {
  public static TableName: string = "tCORHpaye";
  public static strSuffixe: string = "RHP";
}
export class tCOHistoRHpaye {
  public static TableName: string = "tCOHistoRHpaye";
  public static strSuffixe: string = "RHP";
}
export class tCODocument {
  public static TableName: string = "tCODocument";
}
export class tCORapprochement {
  public static TableName: string = "tCORapprochement";
}
export class tDOHistoriqueLigne {
  public static TableName: string = "tDOHistorique";
}
export class tDOGroupe {
  public static TableName: string = "tDOGroupe";
}
export class tDOProduit {
  public static TableName: string = "tDOProduit";
}
export class tDOProtocole {
  public static TableName: string = "tDOProtocole";
}
export class tPAColis {
  public static TableName: string = "tPAColis";
}
export module TCNXSocieteUser {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strName: string = "Name_USE";
    public static strBase: string = "Base_SOC";
  }
}
export module TCNXHisto {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strName: string = "Name_HIS";
    public static strPassw: string = "PasswHIS";
    public static datDate: string = "Date_HIS";
    public static strIP: string = "IP___HIS";
  }
}
export module TCNXSociete {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strName: string = "Name_SOC";
    public static strBase: string = "Base_SOC";
    public static strAdresse: string = "AdresSOC";
    public static strImage: string = "ImageSOC";
    public static strRedirect: string = "RedirSOC";
    public static strWebSiteExpert: string = "Site_SOC";
    public static strDataFolder: string = "Data_SOC";
    public static strDataBaseServer: string = "DBappSOC";
    public static strWebServiceAPI: string = "WSapiSOC";
    public static strWebStreamAPI: string = "WStreSOC";
    public static strLoginPortail: string = "ExSitSOC";
  }
}
export module TBOListe {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCodeBO: string = "Code_BOL";
    public static strInfo: string = "Info_BOL";
    public static strSelect: string = "SelecBOL";
    public static strCodeTable: string = "TblcoBOL";
  }
}
export module TBOProperty {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strGroupeValue: string = "GrpvaBOP";
    public static strTypeColonne: string = "TycolBOP";
    public static strTitreGroupe: string = "TigrpBOP";
    public static strTitre: string = "TitreBOP";
    public static strMethode: string = "MethoBOP";
    public static strMask: string = "Mask_BOP";
    public static strInfo: string = "Info_BOP";
    public static intGroupe: string = "GroupBOP";
    public static intOrdreDsGrp: string = "OrgrpBOP";
    public static intHeight: string = "HeighBOP";
    public static intWidth: string = "WidthBOP";
    public static strValueDefaut: string = "ValdfBOP";
    public static intObligatoire: string = "ObligBOP";
    public static intHistorisable: string = "HistoBOP";
    public static strNoSelectable: string = "NoselBOP";
    public static strRegexpression: string = "RegexBOP";
    public static strCodeColumn: string = "ColcoBOP";
    public static strCodeIdent: string = "Code_BOP";
    public static strSQL: string = "Sql__BOP";
    public static intAutoUpdate: string = "MajcoBOP";
    public static strAckKey: string = "AckKey";
    public static intRAZ: string = "RAZvaBOP";
  }
}
export module TBOValue {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strId_BOP: string = "IdbopBOV";
    public static strValue_str: string = "VastrBOV";
    public static strValue_int: string = "VaintBOV";
    public static strValue_img: string = "VaimgBOV";
    public static strInfo: string = "Info_BOV";
  }
}
export module TDOPeres {
  export class Cols {
    public static intIdent: string = "IdentPER";
    public static intIdTable: string = "IdtblPER";
  }
}
export module TPAStock {
  export class Cols {
    public static intIdent: string = "Ident";
    public static idSite: string = "IdSitOCK";
    public static idProduit: string = "IdProOCK";
    public static QtyStock: string = "QtyPrOCK";
  }
}
export module TDOSalaire {
  export class Cols {
    public static intIdent: string = "Ident";
    public static Salaire: string = "SalaiSal";
    public static PrimSalaire: string = "PrimeSAL";
    public static PrimVacances: string = "PriVaSAL";
    public static MutuelleCol: string = "MutueSAL";
    public static PlanEpargne: string = "PEE__SAL";
    public static Prevoyance: string = "PrevoSAL";
    public static CarteOrange: string = "CaOraSAL";
    public static NbHeure: string = "NbHeuSAL";
    public static CoutHoraire: string = "CoHorSAL";
    public static ChargeSalaire: string = "ChSalSAL";
    public static ChargePrime: string = "ChPriSAL";
    public static ChargePrimeVac: string = "ChPVaSAL";
    public static ChargeSalaire1: string = "ChargSAL";
  }
}
export module TDOFicheTech {
  export class Cols {
    public static intIdent: string = "Ident";
    public static Nom: string = "NomTeFIC";
    public static Fabrication: string = "FabriFIC";
    public static Type: string = "Type_Fic";
    public static Unite: string = "UnitFIC";
    public static Code: string = "Code_FIC";
    public static Quantite: string = "QuantFIC";
    public static Besoin: string = "BesoiFIC";
    public static Conditionnement: string = "CondiFIC";
    public static IdProduit: string = "IdProdFIC";
  }
}
export module TDOFiche {
  export class Cols {
    public static intIdent: string = "Ident";
    public static NomSite: string = "Nom_Site";
    public static Origine: string = "OrigiFIC";
    public static DateDerniere: string = "DatMaFIC";
    public static Nom: string = "Nom_FIC";
    public static Code: string = "Code_FIC";
    public static NumeroAutoFic: string = "NumerFIC";
    public static CompatibiliteNormal: string = "CompaFIC";
    public static CompatibiliteSsporc: string = "SsPorFIC";
    public static CompatibiliteMix: string = "ComMiFIC";
    public static CompatibiliteHyp: string = "HyperFIC";
    public static CompatibiliteSsg: string = "CoSsgFIC";
    public static CompatibiliteDia: string = "CoDiaFIC";
    public static Descriptif: string = "DescrFIC";
    public static Coefficient: string = "CoeffFIC";
    public static Appartenance: string = "ApparFIC";
    public static CoeffAdulte: string = "AdultFIC";
    public static Coeff3Age: string = "Qty3AFIC";
    public static CoeffPrim: string = "PrimaFIC";
    public static CoeffMat: string = "MaterFIC";
    public static NbAduFIC: string = "NbAduFIC";
    public static DateLimiteCons: string = "DaLimFIC";
    public static Etiquetage: string = "EtiquFIC";
  }
}
export module TDOLicence {
  export class Cols {
    public static IntIdent: string = "Ident";
    public static AccessKey: string = "AckKey";
    public static IdentClient: string = "IdenCltLis";
    public static AccessCode: string = "AccessCodLis";
    public static ExpirationDate: string = "ExpirDateLis";
    public static BaseName: string = "NomBaseLis";
    public static LicenceNumber: string = "NbLis";
    public static IPServeur: string = "IPServLis";
    public static DateDemande: string = "DateDemLis";
    public static Authorisation: string = "AuthoLis";
    public static CodeVersion: string = "CoVerLis";
    public static NbLicFac: string = "NuUFaLIS";
    public static AccesPortail: string = "AcporLIS";
    public static NbLicPortail: string = "NbPorLIS";
  }
}
export module TTODisplay {
  export class Cols {
    public static NomDisplay: string = "NomDis";
    public static CodeDisplay: string = "CodeDis";
    public static CssFile: string = "CSSFileDis";
    public static PersistenceDisplay: string = "PersDis";
    public static DefaultDisplay: string = "DefaultDis";
    public static ImageDisplay: string = "ImageDis";
    public static IconeDisplay: string = "IconeDis";
    public static ForceDisplay: string = "ForceDis";
    public static PictogramDisplay: string = "PictoDis";
    public static HeritageDisplay: string = "HeritDis";
    public static CssIdDis: string = "CssIdDis";
    public static ColorDIS: string = "ColorDis";
    public static DOCTYPE: string = "DocTyDIS";
  }
}
export module TDOLien {
  export class Cols {
    public static intIdent: string = "IdLien";
    public static intIdRelation: string = "IddorLIE";
    public static intIdPere: string = "Pere_LIE";
    public static intIdFils: string = "Fils_LIE";
    public static intIdentUser: string = "IdusrLIE";
    public static datCreation: string = "DatcrLIE";
  }
}
export module TPALienInfo {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdLien: string = "IdLieLIF";
    public static intIdRelation: string = "IddorLIF";
    public static intIdPere: string = "Pere_LIF";
    public static intIdFils: string = "Fils_LIF";
    public static strInf01: string = "Inf01LIF";
    public static strInf02: string = "Inf02LIF";
    public static dtdat01: string = "dat01LIF";
    public static intOrdre: string = "OrdreLIF";
    public static dtSignature: string = "dtSigLIF";
    public static strNomSignature: string = "fiSigLIF";
    public static strIpSignataire: string = "ipSigLIF";
  }
}
export module TPAProduit {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strDesignation: string = "DesigPRO";
    public static strDescription: string = "DescrPRO";
    public static strPrerequis: string = "PreRePRO";
    public static strPublic: string = "PubliPRO";
    public static strProgram: string = "ProgrPRO";
    public static strPedago: string = "PedagPRO";
    public static monPrix: string = "Prix_PRO";
    public static monPrix2: string = "Prix2PRO";
    public static monPrix3: string = "Prix3PRO";
    public static monPrix4: string = "Prix4PRO";
    public static strFormule: string = "FormuPRO";
    public static strCodeArticleFact: string = "CodauPRO";
    public static strCodePresta: string = "prestPRO";
    public static strUnite: string = "UnitePRO";
    public static intNbUnite: string = "NbuniPRO";
    public static intOrder: string = "OrdrePRO";
    public static strAcKkey: string = "AckKey";
    public static strConditionnement: string = "CondiPRO";
    public static strType: string = "Type_PRO";
    public static strTva: string = "TxTvaPRO";
    public static strCode: string = "Code_PRO";
    public static intCapaStagiaire: string = "CastaPRO";
    public static intDuree: string = "DureePRO";
    public static intDureeJour: string = "NbjouPRO";
    public static bolCalculDuree: string = "CalDuPRO";
    public static intNbminSta: string = "caminPRO";
    public static strNbrSession: string = "SessiPRO";
    public static strOption: string = "OptioPRO";
  }
}
export module TPACategorie {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNom: string = "Nom__CAT";
    public static intOrdre: string = "OrdreCAT";
    public static strAcKkey: string = "AckKey";
    public static intInWeb: string = "InWebCAT";
    public static strImage: string = "ImgExCAT";
  }
}
export module TDORelation {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strGroupe: string = "GroupDOR";
    public static strPereToFils: string = "Ptof_DOR";
    public static strFilsToPere: string = "Ftop_DOR";
    public static strInfo: string = "Info_DOR";
    public static strModeFilsToPere: string = "MoftpDOR";
    public static strModePereToFils: string = "MoptfDOR";
    public static strCodeIdent: string = "Code_DOR";
    public static strIdBoPere: string = "BoperDOR";
    public static strIdBoFils: string = "BofilDOR";
    public static strIdRelOrigine: string = "RelorDOR";
    public static intOrdreDeTri: string = "OrdreDOR";
  }
}
export module TDOEvenement {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCode: string = "Code_EVE";
    public static strStatut: string = "StatuEVE";
    public static strValue: string = "ValueEVE";
    public static strObjet: string = "ObjetEVE";
    public static strEmplacement: string = "EmplaEVE";
    public static strType: string = "Type_EVE";
    public static datDebut: string = "DatedEVE";
    public static strInformations: string = "Info_EVE";
    public static strInfoProduit: string = "InfoPEVE";
    public static strCommentaires: string = "CommeEVE";
    public static NbAduEVE: string = "NbAduEVE";
    public static Nb3AgEVE: string = "Nb3AgEVE";
    public static NbPriEVE: string = "NbPriEVE";
    public static MaterEVE: string = "MaterEVE";
    public static MeTotEVE: string = "MeTotEVE";
    public static datFin: string = "DatefEVE";
    public static bolJourEntier: string = "AldayEVE";
    public static strAmPm: string = "AMPM_EVE";
    public static strDisponibilite: string = "DispoEVE";
    public static timRemind: string = "reminEVE";
    public static datAlert: string = "AlertEVE";
    public static intEtat: string = "Etat_EVE";
    public static intDuree: string = "dureeEVE";
    public static monMontant: string = "MontaEVE";
    public static intPonderation: string = "PondeEVE";
    public static monRemise: string = "RemisEVE";
    public static monMontantHTApRem: string = "Mtht_EVE";
    public static bolPrive: string = "ConfiEVE";
    public static intMillesime: string = "MilleEVE";
    public static strCategorie: string = "CategEVE";
    public static intJourDuMois: string = "rcDoMEVE";
    public static intMoisAnnee: string = "rcMoYEVE";
    public static intInstance: string = "rcInsEVE";
    public static intIntervale: string = "rcIntEVE";
    public static intOccurences: string = "rcOccEVE";
    public static strJours: string = "rcDoWEVE";
    public static strPeriodicite: string = "rcTypEVE";
    public static datDebutPeriodicite: string = "rcDtDEVE";
    public static datFinPeriodicite: string = "rcDtFEVE";
    public static bolPasDateDeFin: string = "rcEndEVE";
    public static strGroupe: string = "GroupEVE";
    public static strInterlocuteur: string = "Nomc_EVE";
    public static strNumeroTel: string = "NumteEVE";
    public static intPriorite: string = "Prio_EVE";
    public static strWorkflow: string = "WorkfEVE";
    public static strIdentMere: string = "IdMerEVE";
    public static strIdApp: string = "IdAppEVE";
    public static bolPeriodique: string = "RDVPERIO";
    public static MidP1EVE: string = "MidP1EVE";
    public static MidP2EVE: string = "MidP2EVE";
    public static MidP3EVE: string = "MidP3EVE";
    public static MidP4EVE: string = "MidP4EVE";
    public static MidP5EVE: string = "MidP5EVE";
    public static SoiP1EVE: string = "SoiP1EVE";
    public static SoiP2EVE: string = "SoiP2EVE";
    public static SoiP3EVE: string = "SoiP3EVE";
    public static SoiP4EVE: string = "SoiP4EVE";
    public static SoiP5EVE: string = "SoiP5EVE";
    public static IdMi1EVE: string = "IdMi1EVE";
    public static IdMi2EVE: string = "IdMi2EVE";
    public static IdMi3EVE: string = "IdMi3EVE";
    public static IdMi4EVE: string = "IdMi4EVE";
    public static IdMi5EVE: string = "IdMi5EVE";
    public static IdSo1EVE: string = "IdSo1EVE";
    public static IdSo2EVE: string = "IdSo2EVE";
    public static IdSo3EVE: string = "IdSo3EVE";
    public static IdSo4EVE: string = "IdSo4EVE";
    public static IdSo5EVE: string = "IdSo5EVE";
    public static EtatConge: string = "EtValEVE";
    public static HistoriqueConge: string = "HisCoEVE";
    public static ZoneCodeRH: string = "CodEvEVE";
    public static TypeConge: string = "TypCoEVE";
    public static NbJourDecompte: string = "NbJDeEVE";
    public static NbJourPoses: string = "NbJPoEVE";
    public static NbJourTotal: string = "NbjToEVE";
    public static NbJourRestant: string = "NbjReEVE";
    public static datSynchroOutlook: string = "DaSynEVE";
    public static SynchronisationOutlook: string = "SynchEVE";
    public static NumeroAffaire: string = "refInEVE";
    public static NombreNuit: string = "NbnuitEVE";
    public static PrixParNuit: string = "PrixnEVE";
    public static TotalPrixNuit: string = "TotnuEVE";
    public static bolTraite: string = "TraitEVE";
    public static strIssue: string = "IssueEVE";
    public static strNbrInscrits: string = "NbInsEVE";
    public static strNbrMaxInscrits: string = "NbTotEVE";
    public static strNumJourForm: string = "JourJEVE";
    public static strResponsable: string = "RespoEVE";
    public static strJourEcheance: string = "echeaEVE";
    public static monPrixUnit: string = "PrixUEVE";
    public static strZoomUrl: string = "Zoom_EVE";
    public static strUrlVideoZoom: string = "UrlZoEVE";
  }
}
export module TDODossier {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strValue: string = "ValueDOS";
    public static strBody: string = "Body_DOS";
    public static strSubject: string = "CreatDOS";
    public static datEnvoie: string = "Date_DOS";
    public static intEtat: string = "Etat_DOS";
    public static intOrdre: string = "OrdreDOS";
    public static strCode: string = "Code_DOS";
    public static strNom: string = "NucliDOS";
    public static strAdresse: string = "NucasDOS";
    public static strDateProgramme: string = "ProgrDOS";
    public static strTypeMail: string = "TypeMDOS";
    public static strReportMail: string = "RprtMDOS";
  }
}
export module TDOCatalogue {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNom: string = "Name_CTL";
    public static intOrdre: string = "OrdreCTL";
    public static intInWeb: string = "InWebCTL";
    public static strImage: string = "ImgExCTL";
  }
}
export module TDOConnaissance {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strTitre: string = "TitreCON";
    public static strDescription: string = "Desc_CON";
    public static strOrdre: string = "OrdreCON";
    public static strInWeb: string = "InWebCON";
    public static strModule: string = "ModulCON";
    public static strType: string = "Type_CON";
    public static strCategorie: string = "Typ01CON";
    public static strThematique: string = "problCON";
    public static strInfos: string = "resolCON";
    public static strDiffusion: string = "Typ02CON";
    public static strAuteur: string = "AuteuCON";
    public static strDateCreation: string = "DatCrCON";
    public static strVideo: string = "Path_CON";
    public static strTypeVideo: string = "TypViCON";
    public static strDocument: string = "Path1CON";
    public static strTypeDocument: string = "TypDoCON";
    public static strQuestionnaire: string = "QuestCON";
    public static strExercice: string = "ExercCON";
    public static strHtml: string = "Html_CON";
    public static intIdFormateur: string = "FormaCON";
    public static intTimeBeforeValid: string = "TeValCON";
    public static intIdQuestionnaire: string = "IdQueCON";
    public static intIdExercice: string = "IdExeCON";
  }
}
export module TDOChapitre {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strTitre: string = "TitreCHA";
    public static strDescription: string = "DescrCHA";
    public static strOrdre: string = "OrdreCHA";
    public static strTemps: string = "TempsCHA";
    public static strObjectif: string = "ObjecCHA";
    public static bolRespOrdre: string = "ReOrdCHA";
    public static bolRespOrdreLesson: string = "ReOrLCHA";
    public static strPhoto: string = "PhotoCHA";
    public static bolScorm: string = "ScormCHA";
    public static strUrlScorm: string = "UrlScCHA";
    public static strCodeAuteur: string = "CoAutCHA";
  }
}
export module TDOCatalogueEL {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNom: string = "Name_CEL";
    public static strDescription: string = "DescrCEL";
    public static intOrdre: string = "OrdreCEL";
  }
}
export module TPACycle {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCode: string = "Code_CYC";
    public static strChapitreList: string = "ChapiCYC";
  }
}
export module TDOCycleEL {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCode: string = "Code_CYC";
    public static strName: string = "Name_CYC";
    public static strQuestionnaire: string = "QuestCYC";
    public static strPhoto: string = "PhotoCYC";
  }
}
export module TDOAvancementEL {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdApprenant: string = "IdCntAVA";
    public static intIdCycle: string = "IdCycAVA";
    public static intIdChapitre: string = "IdChaAVA";
    public static strListLessonValid: string = "LstLeAVA";
    public static intIdLecon: string = "IdLecAVA";
    public static bolIsValidate: string = "ValidAVA";
    public static bolVideoChecked: string = "Path_AVA";
    public static bolDocChecked: string = "Path1AVA";
    public static bolQuestChecked: string = "QuestAVA";
    public static bolExercChecked: string = "ExercAVA";
    public static strNotesHtml: string = "NotesAVA";
    public static intAvis: string = "Avis_AVA";
  }
}
export module TDOHistoriqueEL {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdApprenant: string = "IdCntHEL";
    public static intIdCycle: string = "IdCycHEL";
    public static intIdChapitre: string = "IdChaHEL";
    public static intIdLesson: string = "IdLecHEL";
    public static tmpTemps: string = "TempsHEL";
    public static dtjourCnx: string = "JourCHEL";
    public static dtImport: string = "imporHEL";
    public static intIdReservation: string = "IdResHEL";
  }
}
export module TQUModelQuestionnaire {
  export class Cols {
    public static intIdent: string = "Ident";
    public static Model: string = "modelMOD";
    public static Titre: string = "titreMOD";
    public static Description: string = "descrMOD";
    public static NbQuestion: string = "nbqueMOD";
    public static Date: string = "date_MOD";
    public static IsElearning: string = "elearMOD";
    public static NotePassage: string = "NotePMOD";
    public static NoteMax: string = "NoteMMOD";
    public static MessageDeFin: string = "MsgFiMOD";
  }
}
export module TQUModelQuestion {
  export class Cols {
    public static intIdent: string = "Ident";
    public static Titre: string = "TitreMQU";
    public static TypeElement: string = "TypeEMQU";
    public static Type: string = "Type_MQU";
    public static Obligatoire: string = "RequiMQU";
    public static Indice: string = "Hint_MQU";
    public static Note: string = "Note_MQU";
    public static Ordre: string = "OrdreMQU";
    public static Page: string = "Page_MQU";
    public static ControlType: string = "TypeCMQU";
    public static ControlValue: string = "ValC_MQU";
    public static GroupeName: string = "groupMQU";
    public static GroupePoint: string = "NoteGMQU";
  }
}
export module TQUModelReponse {
  export class Cols {
    public static intIdent: string = "Ident";
    public static Titre: string = "TitreMRE";
    public static Juste: string = "JusteMRE";
    public static Note: string = "Note_MRE";
    public static Ordre: string = "OrdreMRE";
    public static ControlType: string = "TypeCMRE";
    public static ControlValue: string = "ValC_MRE";
    public static Msg: string = "Msg__MRE";
    public static Redir: string = "RedirMRE";
  }
}
export module TQUReponse {
  export class Cols {
    public static intIdent: string = "Ident";
    public static TypeElement: string = "TypeEREP";
    public static IdQuestionnaire: string = "IdQueREP";
    public static TypeQuestion: string = "Type_REP";
    public static Question: string = "QNameREP";
    public static ListReponse: string = "Rep__REP";
    public static UserReponse: string = "ReponREP";
    public static Note: string = "PointREP";
    public static NoteMax: string = "MaxPtREP";
    public static NumQuestion: string = "NumQ_REP";
    public static Juste: string = "JusteREP";
    public static Page: string = "Page_REP";
    public static GroupeName: string = "groupREP";
    public static GroupePoint: string = "NoteGREP";
    public static MediaReponse: string = "MedreREP";
    public static MediaQuestion: string = "MedquREP";
  }
}
export module TQUQuestionnaire {
  export class Cols {
    public static intIdent: string = "Ident";
    public static IdStage: string = "IdStgQUE";
    public static IdCnt: string = "IdCntQUE";
    public static TypeQuestionnaire: string = "TitreQUE";
    public static Note: string = "Note_QUE";
    public static NotePassage: string = "NotePQUE";
    public static NoteMax: string = "NoteMQUE";
    public static IsChecked: string = "CheckQUE";
    public static IdModuleEL: string = "IdLecQUE";
    public static DateCrea: string = "Date_QUE";
    public static NomQuestionnaire: string = "NomQ_QUE";
    public static DescriptionQuestionnaire: string = "DescrQUE";
    public static MsgFinQuestionnaire: string = "MsgF_QUE";
  }
}
export module TDODocument {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intNiveauDocument: string = "NivseDOC";
    public static strNumTr: string = "NumTRDOC";
    public static intNbStagiaire: string = "NbstaDOC";
    public static strReference: string = "RefInDOC";
    public static monCoutUnitaire: string = "CouniDOC";
    public static intEtat: string = "Etat_DOC";
    public static strAffect: string = "AfectDOC";
    public static strUnite: string = "UniteDOC";
    public static strModCalcul: string = "ModcaDOC";
    public static tmpDuree: string = "HeursDOC";
    public static strDureeHeure: string = "DureeDOC";
    public static strDureeJour: string = "NbJouDOC";
    public static strModeCalculHeureJour: string = "ModHJDOC";
    public static strCoutHoraire: string = "CoutHDOC";
    public static intNbUnite: string = "NbuniDOC";
    public static strTitre: string = "TitreDOC";
    public static strCreateur: string = "CreatDOC";
    public static strAdresse: string = "AdresDOC";
    public static datCreation: string = "DtcreDOC";
    public static bolReadOnly: string = "RonlyDOC";
    public static strPath: string = "Path_DOC";
    public static NumeroDOC: string = "numerDOC";
    public static EtatDOC: string = "Etat_DOC";
    public static strMillesimeDOC: string = "MilleDOC";
    public static strTVAIntra: string = "ReTVADOC";
    public static strTauxTVA: string = "TVA__DOC";
    public static strReglement: string = "RegleDOC";
    public static strDateEcheanceDOC: string = "DecheDOC";
    public static dtDateEcheanceFacture: string = "DtEchDOC";
    public static intNbreOccurenceReglement: string = "OcRegDOC";
    public static strPeriodiciteReglement: string = "PeregDOC";
    public static strNombreJourReglement: string = "NbJoRDOC";
    public static strFinMoisReglement: string = "FinMoDOC";
    public static strNumFacture: string = "NumfaDOC";
    public static strNumFactureContrepassee: string = "NFConDOC";
    public static strNomClient: string = "RaisoDOC";
    public static strNomClientDO: string = "RaiDoDOC";
    public static strInfo: string = "Info_DOC";
    public static monMontantReg: string = "MtregDOC";
    public static intNumRelance: string = "NrelaDOC";
    public static monMontant: string = "MontaDOC";
    public static strTarif: string = "TarifDOC";
    public static monTTChorsRemise: string = "MoTTCDOC";
    public static monHT: string = "MonhtDOC";
    public static monRemiseHT: string = "mthtrdoc";
    public static monRemise: string = "RemisDOC";
    public static monRemiseCONV: string = "MontrDOC";
    public static monTotalHT: string = "MTHT_DOC";
    public static monTotalTVA: string = "MTTVADOC";
    public static monTTCapresRemise: string = "MtTTCDOC";
    public static monSoldeTTCapresRemise: string = "MtSolDOC";
    public static monSoldeARegler: string = "SoRegDOC";
    public static monTotalRemise: string = "MTRemDOC";
    public static monTotalAcompte: string = "MtAcpDOC";
    public static bolImput: string = "ImputDOC";
    public static strType: string = "Type_DOC";
    public static strEntite: string = "EntitDOC";
    public static strGroupe: string = "GroupDOC";
    public static strTypeFacture: string = "TypeFDOC";
    public static strInfoFactureAvoir: string = "FacAvDOC";
    public static strNomOrigine: string = "NorigDOC";
    public static strCurrentUser: string = "ExtraDOC";
    public static datLivraison: string = "DtlivDOC";
    public static datRelance: string = "DtenvDOC";
    public static strCommentaire: string = "CommeDOC";
    public static bolCheckRelance: string = "CkrelDOC";
    public static bolCheckDPCU: string = "DPCU_DOC";
    public static strEcheancier: string = "EcheaDOC";
    public static strNumeroInterne: string = "NuminDOC";
    public static strNumeroAuto: string = "NumAuDOC";
    public static strNumeroAffaire: string = "NTradDOC";
    public static strVersion: string = "VersiDOC";
    public static strNumeroDevis: string = "NumdoDOC";
    public static datSignature: string = "DtSigDOC";
    public static groupeFamille: string = "FamilDOC";
    public static preparationEnCours: string = "FLockDOC";
    public static strCodeAnalytique: string = "ComplDOC";
    public static strModeFacturation: string = "ModeFDOC";
    public static dtAcquitteeLe: string = "DtAcqDOC";
    public static authoriserValidation: string = "AValiDOC";
  }
}
export module TDOPrestation {
  export class Cols {
    public static intIdent: string = "Ident";
    public static AckKey: string = "AckKey";
    public static dblMontant: string = "MontaPRE";
    public static dblRemise: string = "MontRPRE";
    public static dblDuree: string = "DureePRE";
    public static bolCloture: string = "ClotePRE";
    public static bolValide: string = "ValidPRE";
    public static bolExcluBPF: string = "ExcbpPRE";
    public static strInfoProduit: string = "InfoPPRE";
    public static strInfo: string = "Info_PRE";
    public static strDate: string = "DatedPRE";
    public static strNbBulletin: string = "NbBltPRE";
    public static strTaux: string = "Taux_PRE";
    public static strMillesime: string = "MillePRE";
    public static monMontantFacture: string = "MontfPRE";
    public static strCompte: string = "NcompPRE";
    public static strCodeAuto: string = "CodauPRE";
    public static strCommentaire: string = "Info_PRE";
    public static strEntite: string = "EntitPRE";
    public static strGroupe: string = "GroupPRE";
    public static datDebutFacturation: string = "DatdfPRE";
    public static datFinFacturation: string = "DatffPRE";
    public static strCodeAnalytique: string = "ComplPRE";
    public static strCodeArticle: string = "articPRE";
    public static bolDerniereFactureEffectue: string = "FaEffPRE";
    public static strUser: string = "USER_PRE";
    public static strNomFamille: string = "NomfaDOL";
    public static strPrenomPatient: string = "PrenoDOL";
    public static intIdPatient: string = "IdpatDOL";
    public static strAccessNumber: string = "AcnumDOL";
    public static strSexe: string = "Sexe_DOL";
    public static strModaliteImagerie: string = "ModimDOL";
    public static datDateNaissance: string = "DatenDOL";
    public static strAnatomie: string = "AnatoDOL";
    public static strPathologie: string = "PathoDOL";
    public static strMedecinPrescripteur: string = "MedecDOL";
    public static datHeureExamen: string = "DateeDOL";
    public static strDescription: string = "DescrDOL";
    public static strCentreAbonne: string = "CentrDOL";
    public static strMedecinDemandeur: string = "MedeeDOL";
    public static strTelRadio: string = "TelcrDOL";
    public static strTelediagnostic: string = "TeledDOL";
    public static strRegion: string = "RegioDOL";
    public static strIndicClinique: string = "IndicDOL";
    public static strMailRadioDemandeur: string = "EmailDOL";
    public static strMobile: string = "TelmoDOL";
    public static strFaxRadiologue: string = "FaxcrDOL";
    public static strUrlExamenDistant: string = "UrlexDOL";
    public static strUrlExamenLocal: string = "UrlloDOL";
    public static strNomExpert: string = "NomexDOL";
    public static strPrenomExpert: string = "PreexDOL";
    public static strMailExpert: string = "EmaexDOL";
    public static strTelephoneExpert: string = "TelexDOL";
    public static strCommentaireDOL: string = "Info_DOL";
    public static strConclusionDOL: string = "ConclDOL";
    public static strJustificationDOL: string = "JustiPRE";
    public static strRajoutCom: string = "RajcoDOL";
    public static strEtat: string = "Etat_DOL";
    public static strNumER: string = "NunicDOL";
    public static strType: string = "Type_PRE";
    public static strPrioriteER: string = "PriorDOL";
    public static strAntecedentER: string = "AntecDOL";
    public static strSpecialiteER: string = "SpeciPRE";
    public static strInstitutionER: string = "InstiPRE";
    public static strPathologieER: string = "PathoPRE";
    public static strServiceER: string = "ServiPRE";
    public static strIDServiceER: string = "IdSerPRE";
    public static strUnite: string = "UnitePRE";
    public static strPrixUnitaire: string = "PrixUPRE";
    public static strComplement: string = "CommePRE";
    public static strCodeProduit: string = "CodePPRE";
    public static strLibelleFacturation: string = "LibFaPRE";
  }
}
export module TDOInfosFiscalAGACGA {
  export class Cols {
    public static strInfo: string = "Info_FIS";
    public static bolAdhesion: string = "AdcgaIFI";
    public static strService: string = "ServiIFI";
    public static strInterlocuteur: string = "InterIFI";
    public static strNumAgrement: string = "NumagIFI";
    public static strNumAdhesion: string = "NumadIFI";
    public static datDateAdhesion: string = "DtadeIFI";
    public static datDateRadiation: string = "DtradIFI";
    public static datDateEntree: string = "dtcreIFI";
    public static strCapitalSocialDirect: string = "PcsddIFI";
    public static strCapitalSocialIndirect: string = "PcsdiIFI";
    public static strSoumisIS: string = "SouisIFI";
    public static strRegimeImposition: string = "RegimIFI";
    public static strCategorieRevenu: string = "catreIFI";
    public static strActivite: string = "ActivIFI";
    public static strChiffreAffaireHT: string = "ChifaIFI";
    public static strResultatAvantImpot: string = "RcoimIFI";
    public static strRemboursementCapitalEmprunt: string = "RemceIFI";
    public static strNbrSalaries: string = "NbdsaIFI";
    public static bolPersonnelStable: string = "PerssIFI";
    public static strSurfaceExploitation: string = "sufexIFI";
    public static strSubvention: string = "SubveIFI";
    public static bolInterressement: string = "FrpinIFI";
    public static bolPEE: string = "FrppeIFI";
    public static bolAutre1: string = "FrpauIFI";
    public static bolAutre2: string = "FrpeaIFI";
    public static bolPrevoyance: string = "FrpepIFI";
    public static bolMaladie: string = "FrpemIFI";
    public static bolRetraite: string = "FrperIFI";
    public static bolDossierPaye: string = "DpaieIFI";
    public static bolJuridique: string = "JuridIFI";
    public static bolTVTS: string = "Tvts_IFI";
    public static bolScanbank: string = "ScanbIFI";
    public static strScanbankBanque1: string = "Scbq1IFI";
    public static strScanbankBanque2: string = "Scbq2IFI";
    public static strTraitementCpt: string = "TrcptIFI";
    public static strNatureAttestation: string = "NatatIFI";
    public static strNumInspection: string = "NuinsIFI";
    public static strCompteBNC: string = "CpBNCIFI";
    public static strCentreDesImpots: string = "CendiIFI";
    public static strCodeFRP: string = "CofrpIFI";
    public static strArretActivite: string = "AactiIFI";
    public static strTypeTVA: string = "TvaCliIFI";
    public static strExigibTVA: string = "ExtvaIFI";
    public static bolTeleregTVA: string = "TrtvaIFI";
    public static bolEDITVA: string = "EditvIFI";
    public static bolEDITDFC: string = "EditdIFI";
    public static bolMandatTDFC: string = "MtdfcIFI";
    public static strTypeMandatTDFC: string = "MandaIFI";
    public static bolMandatDUCS: string = "MducsIFI";
    public static bolTeleregDUCS: string = "TducsIFI";
    public static bolEDILiasse: string = "EdiliIFI";
  }
}
export module TDOFicheTemps {
  export class Cols {
    public static intIdent: string = "Ident";
    public static datDate: string = "date_FDT";
    public static strActivite: string = "ActivFDT";
    public static strLibelleAuto: string = "LibauFDT";
    public static strLibelleManu: string = "LibmaFDT";
    public static lngTemps: string = "TempsFDT";
    public static strAckKey: string = "AckKey";
    public static intMillesime: string = "MilleFDT";
    public static strPointer: string = "PointFDT";
    public static dblCout: string = "Cout_FDT";
    public static dblCout2: string = "Cout2FDT";
    public static dblCout3: string = "Cout3FDT";
    public static IdFacFDT: string = "IdFacFDT";
  }
}
export module TDOClient {
  export class Cols {
    public static strRaisonSocial: string = "RaisoCLI";
    public static strCivilite: string = "CivilCLI";
    public static strNom: string = "NomfaCLI";
    public static strPrenom: string = "Pre01CLI";
    public static strIdent: string = "Ident";
    public static strTelephone: string = "NutelCLI";
    public static strEmail: string = "EmailCLI";
    public static strEmailFacturation: string = "ExpemCLI";
    public static strAdresse1: string = "Adre1CLI";
    public static strAdresse2: string = "Adre2CLI";
    public static strAdresse3: string = "Adre3CLI";
    public static strAdresse4: string = "Adr4_CLI";
    public static strDenomination: string = "DenomCLI";
    public static strCPVille: string = "VilleCLI";
    public static strCodePostal: string = "AdrCPCLI";
    public static strVille: string = "AdrVICLI";
    public static strLatitude: string = "LatitCLI";
    public static strLongitude: string = "LongiCLI";
    public static strPointGeographique: string = "PtGeoCLI";
    public static strNumFax: string = "NufaxCLI";
    public static strNumCasier: string = "NumcaCLI";
    public static strFormeJuridique: string = "FormjCLI";
    public static strNumRCS: string = "CnrcsCLI";
    public static strNumFRP: string = "NuFrpCLI";
    public static strStatutFiscal: string = "StafiCLI";
    public static strNumSIRET: string = "SiretCLI";
    public static strNumSIREN: string = "sirenCLI";
    public static strNumNAF: string = "NuNafCLI";
    public static strPortable: string = "NuPorCLI";
    public static strNumAPE: string = "NuapeCLI";
    public static strNumeroCompta: string = "NumcoCLI";
    public static strNumeroTel: string = "Nute2CLI";
    public static strPays: string = "NatioCLI";
    public static strAdressePays: string = "Pays_CLI";
    public static strActivite: string = "ActivCLI";
    public static strNote: string = "NotesCLI";
    public static strLocalite: string = "LocalCLI";
    public static datEntree: string = "DateECLI";
    public static datSortie: string = "DtsorCLI";
    public static strLettre1: string = "Lett1CLI";
    public static strLettre2: string = "Lett2CLI";
    public static strLettre3: string = "Lett3CLI";
    public static strNumeroEmmetteur: string = "NumemCLI";
    public static strIdCreancierSEPA: string = "ICS__CLI";
    public static strModeFacturation: string = "ModerCLI";
    public static strGroupeFacturation: string = "GroupCLI";
    public static strEtat: string = "Etat_CLI";
    public static strReport: string = "ReporCLI";
    public static intNbPrestaGratuite: string = "NbgraCLI";
    public static datBDC: string = "DabdcCLI";
    public static datBAT: string = "DabatCLI";
    public static datSite: string = "LisitCLI";
    public static bolBloque: string = "BloquCLI";
    public static strCommentaire: string = "CommeCLI";
    public static strEtablissement: string = "EtablCLI";
    public static strNomCourt: string = "nomIDCLI";
    public static strPrefixeNII: string = "prNIICLI";
    public static strNumTVAIntra: string = "tvaCoCLI";
    public static strNumTel3: string = "Nute3CLI";
    public static strNumTel4: string = "Nute4CLI";
    public static strSiteWeb: string = "Site_CLI";
    public static strRefDossierIbiza: string = "IbizaCLI";
    public static strCompteurFacturation: string = "NbfacCLI";
    public static strInfosCompteurFacturation: string = "InfCfCLI";
    public static bolAdherent: string = "AdherCLI";
    public static strTypeJournal: string = "TypeJCLI";
    public static strCodeBDD_IBIZA: string = "IbizaCLI";
    public static strToken_IBIZA: string = "TkIbiCLI";
    public static strIdentMyDsoManager: string = "IdDSOCLI";
    public static strPasswordMyDsoManager: string = "MpDSOCLI";
    public static strCheminDuDossierMyCompanyFiles: string = "PaMCFCLI";
    public static strTypeTaxePDF: string = "TTAXECLI";
    public static strTauxDeFrais: string = "TauChCLI";
    public static dtDernierFactureValide: string = "DtFacCLI";
    public static bloquerValideFactureDebutMois: string = "MBloqCLI";
    public static strSourcCLI: string = "SourcCLI";
    public static strSecteur: string = "SectCLI";
    public static strMillesimeAdhesion: string = "MilAdCLI";
    public static strMontantAnneeAdhesion: string = "MtAn_CLI";
    public static strMontantMoisAdhesion: string = "MtMoiCLI";
    public static strTypeACLI: string = "TypeACLI";
    public static strDateAdhesion: string = "DtEleCLI";
    public static strDateFinAdhesion: string = "DfadhCLI";
    public static strNumAdhesion: string = "NumerCLI";
    public static strSigleCLI: string = "SigleCLI";
    public static ecartPertesEtProfits: string = "EPetPCLI";
    public static strCodeJournalPertesEtProfits: string = "CjPepCLI";
    public static strNumComptePertes: string = "NcPerCLI";
    public static strNumCompteProfits: string = "NcProCLI";
    public static strModelRelanceName: string = "MoRelCLI";
    public static datDebutPeriode: string = "DebPECLI";
    public static datFinPeriode: string = "FinPECLI";
    public static strBanqueReglement: string = "BqRegCLI";
    public static strModeleEmailFacture: string = "modFaCLI";
    public static strModeleEmailRelanceFacture: string = "modReCLI";
    public static strFacebookLink: string = "FacebCLI";
    public static strTwitterLink: string = "TwittCLI";
    public static strGooglePlusLink: string = "GplusCLI";
    public static strLinkedInLink: string = "LinkeCLI";
    public static strViadeoLink: string = "ViadeCLI";
    public static GoCardlessApiToken: string = "GcTknCLI";
  }
}
export module TDOMillesime {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strMillesime: string = "MillePRO";
    public static DatedMIL: string = "DatedPRO";
    public static DatefMIL: string = "DatefPRO";
    public static MontaMIL: string = "MontaPRO";
    public static strInfo: string = "Info_PRO";
    public static bolCloture: string = "ClotePRO";
    public static monRemise: string = "MontRPRO";
    public static strForfait: string = "forfaPRO";
    public static monMontantFacture: string = "MontfPRO";
    public static strCompte: string = "NcompPRO";
    public static strSaisieEcriture: string = "SaiEcPRO";
    public static strRegImmo: string = "RegImPRO";
    public static strRevCompte: string = "RvCptPRO";
    public static strTenueRegistre: string = "TnuriPRO";
    public static strTenueLivre: string = "TnuliPRO";
    public static strDecTVA: string = "DcTVAPRO";
    public static strLiasse: string = "LiaFiPRO";
    public static strTaxPro: string = "TxProPRO";
    public static strTaxApprentissage: string = "TxAppPRO";
    public static strDocAnnuel: string = "EtDocPRO";
    public static strVehiculeSociete: string = "VehsoPRO";
    public static strBulletinSal: string = "BultinPRO";
    public static strTNS: string = "DeTNSPRO";
    public static strSituation: string = "SiIntPRO";
    public static strRatioCom: string = "RaComPRO";
    public static strEtudePrev: string = "EtPrvPRO";
    public static strTableauDeBord: string = "TabrdPRO";
    public static strTaxeSalaire: string = "TxSalPRO";
    public static strPrevoyanceSal: string = "PreSaPRO";
    public static strPerRegistrePerso: string = "RpPerPRO";
    public static strPerTaxeSalaire: string = "TsPerPRO";
    public static strPerPrevoyanceSal: string = "PsPerPRO";
    public static strPerURSAFF: string = "UrPerPRO";
    public static strPerASSEDIC: string = "AsPerPRO";
    public static strPerCaisseRetraite: string = "CrPerPRO";
    public static strDeclaSociales: string = "DeSocPRO";
    public static strPerSituation: string = "SiPerPRO";
    public static datDateSituation: string = "SiPr2PRO";
    public static strPerRatioCom: string = "RaPerPRO";
    public static datRationCom: string = "RaPr2PRO";
    public static datEtudePrev: string = "EpPerPRO";
    public static strPerTableauDeBord: string = "TbPr2PRO";
    public static datTableauDeBord: string = "TbPr2PRO";
    public static strPerSaisieEcriture: string = "SePerPRO";
    public static strPerRevision: string = "RvPerPRO";
    public static datSaisieEcriture: string = "SePr2PRO";
    public static datRevision: string = "RvPr2PRO";
    public static strSecretariatJuridique: string = "SeJurPRO";
    public static strConstitutionSociete: string = "ConsSoPRO";
    public static datConstitutionSociete: string = "CsPr2PRO";
    public static strPerCaisseConges: string = "CcPerPRO";
    public static strFormationProContinu: string = "FmProPRO";
    public static strDADS2: string = "Dads2PRO";
    public static strDADS1: string = "Dads1PRO";
    public static strContribSociale: string = "ConSoPRO";
    public static strImpotSociete: string = "ImpSoPRO";
    public static bolDerniereFactureEffectue: string = "FaEffPRO";
  }
}
export module TDOProduction {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strRemarque: string = "RemarPRO";
    public static strMillesime: string = "MillePRO";
    public static strModCalcul: string = "ModcaPRO";
    public static monCAPrevu: string = "CaprePRO";
    public static strUnite: string = "UnitePRO";
    public static strDuree: string = "DureePRO";
    public static intTpsEL: string = "TpsELPRO";
    public static intTpsPR: string = "TpsPRPRO";
    public static intTps01: string = "Tps01PRO";
    public static intTps02: string = "Tps02PRO";
    public static intTps03: string = "Tps03PRO";
    public static intTps04: string = "Tps04PRO";
    public static intTps05: string = "Tps05PRO";
    public static intTps06: string = "Tps06PRO";
    public static intTps07: string = "Tps07PRO";
    public static intTps08: string = "Tps08PRO";
    public static intTps09: string = "Tps09PRO";
    public static dtDebut: string = "DatedPRO";
    public static dtFin: string = "DatefPRO";
    public static monMontant: string = "MontaPRO";
    public static monMontantMensuel: string = "MtMoiPRO";
    public static monMontantTVA: string = "MtTVAPRO";
    public static strTauxTVA: string = "TVA__PRO";
    public static monTVA_aprRemise: string = "MrTVAPRO";
    public static monMontantTTC: string = "MtTTCPRO";
    public static intEtat: string = "Etat_PRO";
    public static strInfo: string = "Info_PRO";
    public static strIdActionCO: string = "ActioPRO";
    public static strInfo2: string = "Info2PRO";
    public static strSatelite: string = "SatelPRO";
    public static strModAffaire: string = "ModvePRO";
    public static strType: string = "type_PRO";
    public static dtBasPRO: string = "DtBasPRO";
    public static bolCloture: string = "ClotePRO";
    public static monRemise: string = "MontRPRO";
    public static monHTAvantRemise: string = "MonHTPRO";
    public static monTTCAvantRemise: string = "MoTTCPRO";
    public static monTTCRemise: string = "MtRemPRO";
    public static monPrixUnitaire: string = "PrixuPRO";
    public static strForfait: string = "forfaPRO";
    public static monMontantFacture: string = "MontfPRO";
    public static strCompte: string = "NcompPRO";
    public static strCodeAnalytique: string = "ComplPRO";
    public static strCodeArticle: string = "articPRO";
    public static strSaisieEcriture: string = "SaiEcPRO";
    public static intQuantite: string = "QuantPRO";
    public static intNbUnit: string = "NbuniPRO";
    public static strParticular: string = "PartiPRO";
    public static monCoutUnitaire: string = "CouniPRO";
    public static monCoutUnitaire2: string = "Coun2PRO";
    public static monCoutUnitaire3: string = "Coun3PRO";
    public static monCoutUnitaire4: string = "Coun4PRO";
    public static strRegImmo: string = "RegImPRO";
    public static strRevCompte: string = "RvCptPRO";
    public static strTenueRegistre: string = "TnuriPRO";
    public static strTenueLivre: string = "TnuliPRO";
    public static strTypeSolution: string = "TypsoPRO";
    public static strDecTVA: string = "DcTVAPRO";
    public static strLiasse: string = "LiaFiPRO";
    public static strTaxPro: string = "TxProPRO";
    public static strTaxApprentissage: string = "TxAppPRO";
    public static strDocAnnuel: string = "EtDocPRO";
    public static strVehiculeSociete: string = "VehsoPRO";
    public static strBulletinSal: string = "BultinPRO";
    public static strTNS: string = "DeTNSPRO";
    public static strSituation: string = "SiIntPRO";
    public static strRatioCom: string = "RaComPRO";
    public static strEtudePrev: string = "EtPrvPRO";
    public static strTableauDeBord: string = "TabrdPRO";
    public static strTaxeSalaire: string = "TxSalPRO";
    public static strPrevoyanceSal: string = "PreSaPRO";
    public static strPerRegistrePerso: string = "RpPerPRO";
    public static strPerTaxeSalaire: string = "TsPerPRO";
    public static strPerPrevoyanceSal: string = "PsPerPRO";
    public static strPerURSAFF: string = "UrPerPRO";
    public static strPerASSEDIC: string = "AsPerPRO";
    public static strPerCaisseRetraite: string = "CrPerPRO";
    public static strDeclaSociales: string = "DeSocPRO";
    public static strPerSituation: string = "SiPerPRO";
    public static datDateSituation: string = "SiPr2PRO";
    public static strPerRatioCom: string = "RaPerPRO";
    public static datRationCom: string = "RaPr2PRO";
    public static datEtudePrev: string = "EpPerPRO";
    public static strPerTableauDeBord: string = "TbPr2PRO";
    public static datTableauDeBord: string = "TbPr2PRO";
    public static strPerSaisieEcriture: string = "SePerPRO";
    public static strPerRevision: string = "RvPerPRO";
    public static datSaisieEcriture: string = "SePr2PRO";
    public static datRevision: string = "RvPr2PRO";
    public static strSecretariatJuridique: string = "SeJurPRO";
    public static strConstitutionSociete: string = "ConsSoPRO";
    public static datConstitutionSociete: string = "CsPr2PRO";
    public static datCreation: string = "DtcrePRO";
    public static strPerCaisseConges: string = "CcPerPRO";
    public static strFormationProContinu: string = "FmProPRO";
    public static strDADS2: string = "Dads2PRO";
    public static strDADS1: string = "Dads1PRO";
    public static strContribSociale: string = "ConSoPRO";
    public static strImpotSociete: string = "ImpSoPRO";
    public static monTotalBilan: string = "totBiPRO";
    public static monTotalPdtExploitation: string = "totPePRO";
    public static monTotalPdtFinancier: string = "totPfPRO";
    public static monBaseBareme: string = "basBaPRO";
    public static strFourchetteHeure: string = "fourcPRO";
    public static intBudgetGlobal: string = "totBgPRO";
    public static intD120: string = "D120_PRO";
    public static intCapaciteStagiaire: string = "CapstPRO";
    public static intOrdre: string = "OrdrePRO";
    public static intNbminSta: string = "caminPRO";
    public static datFinMissionCAC: string = "fmCacPRO";
    public static bolObtentionPV: string = "ObtPvPRO";
    public static bolExcluBPF: string = "ExcbpPRO";
    public static intHeureCoCommissaire: string = "hCoCoPRO";
    public static intHorsD120: string = "Hd120PRO";
    public static intTempsInterim: string = "TpsItPRO";
    public static intTempsInventaire: string = "TpsIvPRO";
    public static intTempsFinal: string = "TpsFiPRO";
    public static strEntite: string = "EntitPRO";
    public static strGroupe: string = "GroupPRO";
    public static datDateDebutFacturation: string = "DatdfPRO";
    public static datDateFinFacturation: string = "DatffPRO";
    public static monTaux: string = "Taux_PRO";
    public static strTauxDeFrais: string = "TauChPRO";
    public static strCommentaire: string = "CommePRO";
    public static bolAlert: string = "AlertPRO";
    public static strProduit: string = "ProduPRO";
    public static strNumeroStage: string = "NumstPRO";
    public static strNumeroContrat: string = "NumerPRO";
    public static intNbStagiaire: string = "NbstaPRO";
    public static intNbUtilisateur: string = "NbutiPRO";
    public static strNbrSession: string = "SessiPRO";
    public static intAvanceGRC: string = "AvgrcPRO";
    public static strDesignation: string = "DesigPRO";
    public static strNumeroFacture: string = "NumfaPRO";
    public static datCommande: string = "DatecPRO";
    public static datFirstDevis: string = "dtprePRO";
    public static datDeadLine: string = "deadlPRO";
    public static intChefPole: string = "IdPolPRO";
    public static intChefProjet: string = "IdProPRO";
    public static strDureeJour: string = "NbjouPRO";
    public static strMission: string = "TypMiPRO";
    public static strMontantMensuel: string = "MtMoiPRO";
    public static strMontantAnnuel: string = "MtAn_PRO";
    public static strLibelleFacturation: string = "LibFaPRO";
    public static strListeChapitresEL: string = "ChaelPRO";
    public static intNbHeuresPourDesinscription: string = "NbHDePRO";
  }
}
export module TDOPersonne {
  export class Cols {
    public static strInitiale: string = "TrigrPER";
    public static intIdent: string = "Ident";
    public static strPoste: string = "PostePER";
    public static strNomCnx: string = "Conx_PER";
    public static strNom: string = "NomfaPER";
    public static strPrenom: string = "Pre01PER";
    public static intConfidentialite: string = "ConfiPER";
    public static strPasseWord: string = "passePER";
    public static strSociete: string = "RaisoPER";
    public static strSociete2: string = "SociePER";
    public static strCivilite: string = "CivilPER";
    public static strEmail1: string = "NeproPER";
    public static strEmail2: string = "NuEm2PER";
    public static strNumTelBureau: string = "NtproPER";
    public static strNumTelMobile: string = "NtelpPER";
    public static strNumTelDomicile: string = "NuDomPER";
    public static strNumFax: string = "NfproPER";
    public static strNumeroRue: string = "Apro1PER";
    public static strNomRue: string = "Apro2PER";
    public static strComplementRue: string = "Apro3PER";
    public static strVilleRue: string = "ViproPER";
    public static strCodePostal: string = "AdrCPPER";
    public static strVille: string = "AdrVIPER";
    public static strLatitude: string = "LatitPER";
    public static strLongitude: string = "LongiPER";
    public static strPointGeographique: string = "PtGeoPER";
    public static strInfos: string = "Info_PER";
    public static datDateEntree: string = "DatEnPER";
    public static datDateSortie: string = "DatSoPER";
    public static dblCout: string = "Cout_PER";
    public static dblCout2: string = "Cout2PER";
    public static dblCout3: string = "Cout3PER";
    public static strRegion: string = "RegioPER";
    public static strExpertise: string = "ExperPER";
    public static strExpertise2: string = "Expe2PER";
    public static strExpertise3: string = "Expe3PER";
    public static strExpertise4: string = "Expe4PER";
    public static strExpertise5: string = "Expe5PER";
    public static strFonction: string = "FonctPER";
    public static CompteurRTT: string = "CpRTTPER";
    public static CompteurCP: string = "CpCP_PER";
    public static CompteurCPnmoins1: string = "CpCP1PER";
    public static CompteurRecup: string = "CpRecPER";
    public static CompteurDif: string = "CpDIFPER";
    public static strNiveauNF: string = "NivnfPER";
    public static strVehicule: string = "VehicPER";
    public static intPuissFisc: string = "PufisPER";
    public static strCompte: string = "NumcoPER";
    public static monAvance: string = "AvancPER";
    public static strCalculKM: string = "CalkmPER";
    public static strActif: string = "ActifPER";
    public static lngHMaxJ: string = "HMaxJPER";
    public static strPays: string = "Pays_PER";
    public static strIdResponsable: string = "IdResPER";
    public static strEntiteFacturation: string = "EntitPER";
    public static strGroupeFacturation: string = "GroupPER";
    public static strNumCpt: string = "NumcoPER";
    public static strNumCasier: string = "NumcaPER";
    public static strNumCptCharge: string = "NumCCPER";
    public static strNumCptTVA: string = "NumTVPER";
    public static strTauxTVA: string = "TxTVAPER";
    public static strFileName: string = "File_PER";
    public static strNbrGroupe: string = "NbGrpPER";
    public static strHorsContrat: string = "HoCntPER";
    public static strCycleEL: string = "CyclePER";
    public static strRole: string = "Role_PER";
    public static strPhoto: string = "PhotoPER";
    public static strInWeb: string = "inwebPER";
    public static strDateExpEL: string = "DatELPER";
    public static strEmailZoom: string = "mailZPER";
    public static strCulture: string = "CultuPER";
  }
}
export module TDOObjectif {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strMillesime: string = "MilleOBJ";
    public static monJanvier: string = "JanviOBJ";
    public static monFevrier: string = "FevriOBJ";
    public static monMars: string = "Mars_OBJ";
    public static monAvril: string = "AvrilOBJ";
    public static monMai: string = "Mai__OBJ";
    public static monJuin: string = "Juin_OBJ";
    public static monJuillet: string = "JuillOBJ";
    public static monAout: string = "Aout_OBJ";
    public static monSeptembre: string = "SepteOBJ";
    public static monOctobre: string = "OctobOBJ";
    public static monNovembre: string = "NovemOBJ";
    public static monDecembre: string = "DecemOBJ";
  }
}
export module TDOObjet {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strDenomination: string = "DenomDOO";
    public static strInfo: string = "Info_DOO";
    public static strType: string = "Type_DOO";
    public static bolEdit: string = "EditDOO";
  }
}
export module tUSGroupe {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strTitre: string = "TitreGRP";
    public static strTrigrame: string = "TrigrGRP";
    public static strACKKEY: string = "AckKey";
  }
}
export module TDOAction {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intOrder: string = "OrdreACT";
    public static strTitre: string = "TitreACT";
    public static strTextHisto: string = "TexinACT";
    public static strCode: string = "Code_ACT";
  }
}
export module TDOEntretien {
  export class Cols {
    public static intIdent: string = "Ident";
  }
}
export module TDOGroupeSociete {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strTitre: string = "TitreGSO";
    public static strAckKey: string = "AckKey";
    public static strJournal: string = "JournGSO";
  }
}
export module TDOHistoTache {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strDateEven: string = "DtEveHIT";
    public static strOldCollab: string = "OldNaHIT";
    public static strNewCollab: string = "NewNaHIT";
    public static strTransferePar: string = "CollaHIT";
  }
}
export module TDOHistorique {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strUser: string = "User_HIS";
    public static strAckKey: string = "AckKey";
    public static strInformation: string = "Info_HIS";
    public static dateCreation: string = "Date_HIS";
    public static intSatisfaction: string = "SatisHIS";
    public static strTypeAction: string = "Type_HIS";
    public static strGroupe: string = "GroupHIS";
    public static strIdFrom: string = "IdfrmHIS";
    public static strOldValue: string = "OldvaHIS";
    public static strNewValue: string = "NewvaHIS";
    public static intIdQuoi: string = "IdqoiHIS";
    public static strTypPMHIS: string = "TypPMHIS";
  }
}
export module TDODevis {
  export class Cols {
    public static intIdent: string = "Ident";
    public static monQuantite: string = "QuantDEV";
    public static monPrixUnit: string = "PrixUDEV";
    public static strtauxTVA: string = "TVA__DEV";
    public static monRemisePourcentage: string = "RemipDEV";
    public static monRemise: string = "RemisDEV";
    public static monMontant: string = "MontaDEV";
    public static monMontantHTApRem: string = "Mtht_DEV";
    public static monMontantTTCApRem: string = "MtTTCDEV";
    public static monMontantTTC: string = "MonTTDEV";
    public static monPrixUnitTTC: string = "PrTTUDEV";
    public static monRemiseTTC: string = "RemTTDEV";
    public static monTVA: string = "moTVADEV";
    public static monTVAapremise: string = "MtTVADEV";
    public static monRemiseTVA: string = "ReTVADEV";
    public static monPrixUnitapreremiseHT: string = "PrHTUDEV";
    public static monRemiseUnitaireHT: string = "PrreUDEV";
    public static strLibelle: string = "LibelDEV";
    public static strType: string = "Type_DEV";
    public static intTemps: string = "TempsDEV";
    public static strQualite: string = "QualiDEV";
    public static monMontantHorsMarge: string = "MohmaDEV";
    public static monMarge: string = "MargeDEV";
    public static strCodeArticleFact: string = "CodauDEV";
    public static strCodePresta: string = "prestDEV";
    public static strMillesime: string = "MilleDEV";
    public static monCout: string = "Cout_DEV";
    public static monCoutH: string = "CoutHDEV";
    public static strDate: string = "Date_DEV";
    public static strIdRef: string = "IdRefDEV";
    public static strNFacture: string = "FIdenDEV";
    public static strNumeroDeFacture: string = "numfaDEV";
    public static strInfo: string = "Info_DEV";
    public static strUnite: string = "UniteDEV";
    public static bolInclus: string = "IncluDEV";
    public static strCodeIdentTache: string = "CidenDEV";
    public static strCodeFournisseur: string = "CodFoDEV";
    public static intOrdre: string = "OrdreDEV";
    public static strMode: string = "Mode_DEV";
    public static strMode2: string = "Mode2DEV";
    public static strReference: string = "ReferDEV";
    public static intPoste: string = "PosteDEV";
    public static strCodeAnalytique: string = "ComplDEV";
    public static strQui: string = "Qui__DEV";
    public static strDuree: string = "DureeDEV";
    public static strNbJour: string = "NbjouDEV";
    public static tpsDISTANTIEL: string = "tpsELDEV";
    public static tpsPRESENTIEL: string = "tpsPRDEV";
    public static tps01: string = "tps01DEV";
    public static tps02: string = "tps02DEV";
    public static tps03: string = "tps03DEV";
    public static tps04: string = "tps04DEV";
    public static tps05: string = "tps05DEV";
    public static tps06: string = "tps06DEV";
    public static tps07: string = "tps07DEV";
    public static tps08: string = "tps08DEV";
    public static tps09: string = "tps09DEV";
    public static libelEntiteFact: string = "EntFaDEV";
    public static libelGroupeFact: string = "GrpFaDEV";
    public static idEntiteFact: string = "EntitDEV";
    public static idGroupeFact: string = "GroupDEV";
    public static typeReglement: string = "tyRegDEV";
    public static dateReglement: string = "DtRegDEV";
    public static finDeMoisReglement: string = "FinMoDEV";
    public static nombreJourReglement: string = "NbJoRDEV";
    public static occurenceReglement: string = "OcRegDEV";
    public static periodeReglement: string = "PeregDEV";
    public static compteClient: string = "CptClDEV";
    public static compteTva: string = "CptTvDEV";
    public static compteProduit: string = "CptPrDEV";
    public static codeJournal: string = "codejDEV";
    public static article: string = "ArticDEV";
    public static strGrpLigne: string = "strGrDEV";
    public static idGrpLigne: string = "id_GrDEV";
    public static intOrdreGrpLigne: string = "ordGrDEV";
    public static tauxChancellerie: string = "TauChDEV";
    public static chancellerieHT: string = "HT_ChDEV";
    public static chancellerieTTC: string = "TTCChDEV";
    public static chancellerieTVA: string = "TVAChDEV";
    public static idGrpFamille: string = "GrFamDEV";
    public static dateEmissionFacture: string = "dtFacDEV";
    public static bolExclureBPF: string = "ExcbpDEV";
    public static bolIsDebours: string = "DebouDEV";
    public static labelObjetFacturable: string = "objetDEV";
    public static infoImportArticle: string = "ImporDEV";
  }
}
export module TDOEtablissement {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strDesigETA: string = "DesigETA";
    public static strDejLuETA: string = "DejLuETA";
    public static strDinLuETA: string = "DinLuETA";
    public static strDejMaETA: string = "DejMaETA";
    public static strDinMaETA: string = "DinMaETA";
    public static strDejMeETA: string = "DejMeETA";
    public static strDinMeETA: string = "DinMeETA";
    public static strDejJeETA: string = "DejJeETA";
    public static strDinJeETA: string = "DinJeETA";
    public static strDejVeETA: string = "DejVeETA";
    public static strDinVeETA: string = "DinVeETA";
    public static strDejSaETA: string = "DejSaETA";
    public static strDinSaETA: string = "DinSaETA";
    public static strDejDiETA: string = "DejDiETA";
    public static strDinDiETA: string = "DinDiETA";
    public static strAdresse1: string = "Adre1ETA";
    public static strAdresse2: string = "Adre2ETA";
    public static strAdresse3: string = "Adre3ETA";
    public static strCPVille: string = "VilleETA";
    public static strCedex: string = "CedexETA";
    public static strLatitude: string = "LatitETA";
    public static strLongitude: string = "LongiETA";
    public static strPointGeographique: string = "PtGeoETA";
    public static strTelephone: string = "NutelETA";
    public static strFax: string = "NufaxETA";
    public static strInformations: string = "Info_ETA";
    public static strIDEntite: string = "EntitETA";
    public static strEmail: string = "EmailETA";
    public static bolNotSendEmail: string = "NoMaiETA";
    public static strObjectif01: string = "Obj01ETA";
    public static strObjectif02: string = "Obj02ETA";
    public static strObjectif03: string = "Obj03ETA";
    public static strObjectif04: string = "Obj04ETA";
    public static strObjectif05: string = "Obj05ETA";
    public static strObjectif06: string = "Obj06ETA";
    public static strObjectif07: string = "Obj07ETA";
    public static strObjectif08: string = "Obj08ETA";
    public static strObjectif09: string = "Obj09ETA";
    public static strObjectif10: string = "Obj10ETA";
    public static strObjectif11: string = "Obj11ETA";
    public static strObjectif12: string = "Obj12ETA";
  }
}
export module TDODebours {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strTitre: string = "TitreDEB";
    public static monMontant: string = "MontaDEB";
    public static strCodeAccess: string = "AckKey";
    public static strTVA: string = "TVA__DEB";
    public static Date: string = "Date_DEB";
    public static strType: string = "Type_DEB";
    public static monQuantite: string = "QuantDEB";
    public static monPU: string = "PxuniDEB";
  }
}
export module TDODepense {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strObjet: string = "ObjetDEP";
    public static strType: string = "Type_DEP";
    public static strIdFournisseur: string = "FournDEP";
    public static monCountUnitaire: string = "CouniDEP";
    public static monNombreUnite: string = "NbuniDEP";
    public static strCodeAccess: string = "AckKey";
    public static strTauxTVA: string = "TVA__DEP";
    public static montantHT: string = "PxvalDEP";
    public static montantTVA: string = "MtTVADEP";
    public static montantTTC: string = "MtTTCDEP";
  }
}
export module TDOModeFacturation {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strJour: string = "Jour_MFA";
    public static strModeCalcul: string = "ModecMFA";
    public static strType: string = "Type_MFA";
    public static strJanvier: string = "JanviMFA";
    public static strFevrier: string = "FevriMFA";
    public static strMars: string = "Mars_MFA";
    public static strAvril: string = "AvrilMFA";
    public static strMai: string = "Mai__MFA";
    public static strJuin: string = "Juin_MFA";
    public static strJuillet: string = "JuillMFA";
    public static strAout: string = "Aout_MFA";
    public static strSeptembre: string = "SepteMFA";
    public static strOctobre: string = "OctobMFA";
    public static strNovembre: string = "NovemMFA";
    public static strDecembre: string = "DecemMFA";
    public static strAK: string = "AckKey";
    public static strMoisPlusUn: string = "MnpunMFA";
    public static strSepare: string = "separMFA";
    public static strModeRegl: string = "ModerMFA";
    public static strDelaisRegl: string = "DelaiMFA";
    public static strPeriode: string = "PerioMFA";
    public static strDateDebutFacturation: string = "DatedMFA";
    public static strNbOccurence: string = "OccurMFA";
    public static strArticle: string = "ArticMFA";
    public static strEntiteFacturation: string = "EntitMFA";
    public static strGroupeFacturation: string = "GroupMFA";
    public static strJourReglement: string = "JourrMFA";
    public static strPvtPlusUn: string = "PvtpuMFA";
    public static strRegul: string = "RegulMFA";
    public static strPeriodeReglement: string = "PeregMFA";
    public static strNbOccurenceReglement: string = "OcRegMFA";
    public static strFactureUnique: string = "UniquMFA";
    public static strTypeMissionPresta: string = "TymisMFA";
    public static strFinMoisReglement: string = "FinMoMFA";
    public static strNombreJourReglement: string = "NbJoRMFA";
    public static strGroupeLigne: string = "strGrMFA";
    public static strOrdreLigne: string = "OrdreMFA";
  }
}
export module tDONoteDeFrais {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strRegion: string = "RegioNOF";
    public static dtDate: string = "Date_NOF";
    public static strInfo: string = "Info_NOF";
    public static intCB: string = "CarteNOF";
    public static strNature: string = "NaturNOF";
    public static monMontantHT: string = "MonhtNOF";
    public static monMontantTTC: string = "MottcNOF";
    public static strTauxTVA: string = "Tva__NOF";
    public static monQuantite: string = "QuantNOF";
    public static monPrixUnit: string = "PrixuNOF";
    public static bolFactur: string = "FactuNOF";
    public static strUnite: string = "CatvaNOF";
    public static monEcart: string = "EcartNOF";
    public static strNatureAnalytique: string = "AnalyNOF";
    public static IntIdPiece: string = "IddocNOF";
    public static IntMillesime: string = "MilleNOF";
  }
}
export module TDOBrouillard {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strDate: string = "Date_BRO";
    public static strCodeJournal: string = "CodejBRO";
    public static strCompte: string = "ComptBRO";
    public static monDebit: string = "DebitBRO";
    public static monCredit: string = "CrediBRO";
    public static strLibelle: string = "LibelBRO";
    public static strIntituleCompte: string = "IntitBRO";
    public static strTypeReglement: string = "Type_BRO";
    public static datReglement: string = "DaterBRO";
    public static intExport: string = "ExporBRO";
    public static strEntite: string = "EntitBRO";
    public static strFolio: string = "FolioBRO";
    public static strGroupe: string = "GroupBRO";
    public static strIdEntite: string = "IdEntBRO";
    public static strIdClient: string = "IdCliBRO";
    public static strIdFacture: string = "IdFacBRO";
    public static monPrelevement: string = "MtPreBRO";
    public static strPvt: string = "Pvt__BRO";
    public static intIdAcompte: string = "IdacoBRO";
    public static intIdReglement: string = "IdregBRO";
    public static strComplement: string = "ComplBRO";
  }
}
export module TDORib {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCodeIBAN: string = "IBAN_RIB";
    public static strEtablissement: string = "EtablRIB";
    public static strGuichet: string = "GuichRIB";
    public static strCompte: string = "ComptRIB";
    public static strClef: string = "NucleRIB";
    public static strInfo: string = "Info_RIB";
    public static strCodeJournal: string = "CodejRIB";
    public static strNumeroCompte: string = "NcompRIB";
    public static strCodeBIC: string = "BIC__RIB";
    public static strIdCreancierSEPA: string = "SEPA_RIB";
    public static strMandat: string = "MandaRIB";
    public static strDateSignatureMandat: string = "DtManRIB";
    public static strNouveauMandat: string = "NMandRIB";
    public static strNouvelleDateSignatureMandat: string = "NDtMaRIB";
    public static strEtatPrelevementSEPA: string = "Etat_RIB";
    public static strOrdre: string = "OrderRIB";
    public static strCJPep: string = "CjPepRIB";
    public static strNCPerte: string = "NcPerRIB";
    public static strNCProfit: string = "NcProRIB";
    public static strNCPep: string = "NcPepRIB";
  }
}
export module TDOService {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNom: string = "Nom__SER";
  }
}
export module TDOReglement {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strDate: string = "Date_REG";
    public static strLibelle: string = "LibelREG";
    public static strFolio: string = "FolioREG";
    public static monMontant: string = "MontaREG";
    public static strTypeReglement: string = "Type_REG";
    public static strNumCheque: string = "NcheqREG";
    public static monMontantRegle: string = "MontrREG";
    public static intBanque: string = "BanquREG";
    public static bolEncaissement: string = "EncimREG";
    public static intIdBanque: string = "IdBq_REG";
    public static intIdEntite: string = "IdEntREG";
    public static intIdGroupe: string = "IdgrpREG";
    public static intObservation: string = "Info_REG";
    public static monPerte: string = "PerteREG";
    public static monProfit: string = "ProfiREG";
    public static dtDateAnnulation: string = "DtAnnREG";
    public static strNumFichierSEPA: string = "NumerREG";
    public static intIdEcheancier: string = "IdEchREG";
    public static intIdReglementRattache: string = "IdRegREG";
    public static strIdPaiementGoCardless: string = "GcPayREG";
  }
}
export module TDOTemps {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intInterim: string = "TmIntTMP";
    public static intInventaire: string = "TmInvTMP";
    public static intFinal: string = "TmFinTMP";
    public static monCout: string = "Cout_TMP";
  }
}
export module TDOOption {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNom: string = "Nom__OPT";
    public static strOrdre: string = "OrdreOPT";
    public static strDuree: string = "DureeOPT";
    public static strNbJour: string = "NbjouOPT";
    public static monHT_Montant_remise: string = "MontaOPT";
    public static monHT_Montant: string = "MonHTOPT";
    public static monTTC_Montant: string = "MoTTCOPT";
    public static monTTC_Montant_remise: string = "MtTTCOPT";
    public static monTTC_Remise: string = "MtRemOPT";
    public static monTVA_Montant: string = "MtTVAOPT";
    public static monTVA_avtRemise: string = "MrTVAOPT";
    public static monHT_Remise: string = "MtHTrOPT";
  }
}
export module TDOAdresse {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strAdr1: string = "Adre1ADR";
    public static strAdr2: string = "Adre2ADR";
    public static strAdr3: string = "Adre3ADR";
    public static strVille: string = "VilleADR";
    public static strCodePostal: string = "AdrCPCLI";
    public static strNomVille: string = "AdrVICLI";
    public static strPays: string = "Pays_ADR";
    public static strInfo: string = "Info_ADR";
    public static strDenomination: string = "DenomADR";
    public static strAttentionDe: string = "AttenADR";
    public static strTypeRye: string = "TyRueADR";
    public static strLieuDit: string = "Lieu_ADR";
    public static strLatitude: string = "LatitADR";
    public static strLongitude: string = "LongiADR";
    public static strPointGeographique: string = "PtGeoADR";
    public static strTelephone: string = "NutelADR";
  }
}
export module TDOTarification {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strLibelle: string = "LibelTAR";
    public static monTarifBulletins: string = "BltinTAR";
    public static strPlage: string = "PlageTAR";
  }
}
export module TDOPlanDeCharge {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCodeMission: string = "CodeMPDC";
    public static strCodeTache: string = "CODE_PDC";
    public static strLibelTache: string = "LibelPDC";
    public static strCondition: string = "CondiPDC";
    public static strCodeRelaColla: string = "RelCoPDC";
    public static strCodeTachePar: string = "ParenPDC";
    public static strWorkFlow: string = "WorkFPDC";
    public static intPriorite: string = "PriorPDC";
    public static strChampBdd: string = "ChampPDC";
    public static strDureeUtil: string = "DureePDC";
    public static monCoutGlobal: string = "ForfaPDC";
    public static strQuant: string = "QuantPDC";
    public static strDatFixDefau: string = "DaFixPDC";
    public static strDatFixUtili: string = "UsDatPDC";
    public static strJourFixUtili: string = "UsjouPDC";
    public static strMoiJour: string = "MoJouPDC";
    public static strSens: string = "Sens_PDC";
    public static strDatEven: string = "EvenePDC";
    public static strDebuTache: string = "DebutPDC";
    public static bolDecalage: string = "DecalPDC";
    public static bolTitreDecalageMoisNMoins1: string = "TitNePDC";
    public static bolTitreDecalage: string = "TitDcPDC";
    public static strTypDecal: string = "TyDecPDC";
    public static intExcepTrai: string = "ExeptPDC";
    public static strPeriodiFix: string = "PerioPDC";
    public static strJour: string = "Jour_PDC";
    public static dblCoeff: string = "CoeffPDC";
    public static strCodIdent: string = "CidenPDC";
    public static strActiveCalculPDC: string = "ActivPDC";
    public static strInformation: string = "Info_PDC";
    public static strModeCalcul: string = "CalcuPDC";
    public static strActiveCalculDevis: string = "DevisPDC";
  }
}
export module TDOFamille {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNomMme: string = "Nom01FAM";
    public static strNomMr: string = "Nom02FAM";
    public static strPrenomMme: string = "Pre01FAM";
    public static strPrenomMr: string = "Pre02FAM";
    public static strCivilite: string = "CivilFAM";
    public static strEmail1: string = "EmailFAM";
    public static strNumTelBureau: string = "NtFixFAM";
    public static strNumTelMobile: string = "NtGSMFAM";
    public static strNumeroRue: string = "Adr01FAM";
    public static strNomRue: string = "Adr02FAM";
    public static strComplementRue: string = "Adr03FAM";
    public static strVilleCP: string = "VilleFAM";
    public static strInfos: string = "Info_FAM";
    public static strInfosVisite: string = "VisitFAM";
    public static strHobbies: string = "HobbiFAM";
    public static strAnneeNaissanceMme: string = "Nai01FAM";
    public static strAnneeNaissanceMr: string = "Nai02FAM";
    public static strProfessionMme: string = "Pro01FAM";
    public static strProfessionMr: string = "Pro02FAM";
    public static strNombreChambre: string = "NbrChFAM";
    public static strInfoAcces: string = "AccesFAM";
    public static strFilleGarcon: string = "FiGa_FAM";
    public static bolSDBprivee: string = "SDBprFAM";
    public static bolInternet: string = "WEB__FAM";
    public static strFumeur: string = "FumeuFAM";
    public static strInfoEnfant: string = "EnfanFAM";
    public static strAnimaux: string = "AnimaFAM";
    public static bolVegetarien: string = "VegetFAM";
    public static bolMajeurMineur: string = "MaMi_FAM";
    public static bolPensionComplete: string = "PeComFAM";
    public static bolDemiPension: string = "DemPeFAM";
    public static bolBedAndBreakfast: string = "BandBFAM";
    public static bolChambreCuisine: string = "ChCuiFAM";
  }
}
export module TDOChambre {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNumeroLit: string = "nbLitCHA";
    public static strNumeroChambre: string = "NbChaCHA";
    public static strTypeLit: string = "tyLitCHA";
    public static strDesignation: string = "DesigCHA";
  }
}
export module tDOObligation {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strType_OBL: string = "Type_OBL";
    public static strLibelOBL: string = "LibelOBL";
    public static strLiMisOBL: string = "LiMisOBL";
    public static strTyColOBL: string = "TyColOBL";
    public static intIdCliOBL: string = "IdCliOBL";
    public static intIdMisOBL: string = "IdMisOBL";
    public static intIdColOBL: string = "IdColOBL";
    public static tpsDureeOBL: string = "DureeOBL";
    public static strInformationOBL: string = "Info_OBL";
    public static bolExclureDuSuiviOBL: string = "ExcluOBL";
    public static intMoi01OBL: string = "Moi01OBL";
    public static intMoi02OBL: string = "Moi02OBL";
    public static intMoi03OBL: string = "Moi03OBL";
    public static intMoi04OBL: string = "Moi04OBL";
    public static intMoi05OBL: string = "Moi05OBL";
    public static intMoi06OBL: string = "Moi06OBL";
    public static intMoi07OBL: string = "Moi07OBL";
    public static intMoi08OBL: string = "Moi08OBL";
    public static intMoi09OBL: string = "Moi09OBL";
    public static intMoi10OBL: string = "Moi10OBL";
    public static intMoi11OBL: string = "Moi11OBL";
    public static intMoi12OBL: string = "Moi12OBL";
    public static intVal01OBL: string = "Val01OBL";
    public static intVal02OBL: string = "Val02OBL";
    public static intVal03OBL: string = "Val03OBL";
    public static intVal04OBL: string = "Val04OBL";
    public static intVal05OBL: string = "Val05OBL";
    public static intVal06OBL: string = "Val06OBL";
    public static intVal07OBL: string = "Val07OBL";
    public static intVal08OBL: string = "Val08OBL";
    public static intVal09OBL: string = "Val09OBL";
    public static intVal10OBL: string = "Val10OBL";
    public static intVal11OBL: string = "Val11OBL";
    public static intVal12OBL: string = "Val12OBL";
    public static bolPonctOBL: string = "PonctOBL";
  }
}
export module tDOHistoControle {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCodeHIS: string = "Code_HIS";
    public static strIdentCodeHIS: string = "IdCodHIS";
    public static strIdDonneeHIS: string = "IdDonHIS";
    public static strIdUserHIS: string = "IdUseHIS";
    public static strAncienneValeurHIS: string = "OldVaHIS";
    public static strNouvelleValeurHIS: string = "NewVaHIS";
    public static datDateHeureModifHIS: string = "DtModHIS";
    public static strCommentairesHIS: string = "CommeHIS";
    public static strAckKey: string = "AckKey";
  }
}
export module tDOGuident {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strInfo: string = "Info_GUI";
  }
}
export module tDOMedia {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strPath: string = "Path_MED";
    public static strName: string = "Name_MED";
    public static strTitre: string = "TitreMED";
    public static strType: string = "Type_MED";
    public static datDateCreation: string = "Date_MED";
    public static intNombrePreviews: string = "NbPrvMED";
    public static intNombrePreviewsPersos: string = "NbPrPMED";
    public static strClefAuteur: string = "AuthKMED";
  }
}
export module tDOStatGroupe {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCodeAccess: string = "AckKey";
    public static titre: string = "TitreSGR";
    public static moyenne: string = "MoyenSGR";
    public static tauxReponse: string = "TRep_SGR";
  }
}
export module tDOStatLigne {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCodeAccess: string = "AckKey";
    public static titreStat: string = "TitreSLI";
    public static nom: string = "NomFaSLI";
    public static prenom: string = "PrenoSLI";
    public static datePremiereConn: string = "DtDELSLI";
    public static dateDerniereConn: string = "DtFELSLI";
    public static tempsConn: string = "TmpCoSLI";
    public static titreChapitre: string = "ChapiSLI";
    public static description: string = "DescrSLI";
    public static volumeDeclare: string = "VolDeSLI";
    public static titreResa: string = "TResaSLI";
    public static infos: string = "InfosSLI";
    public static dateDebutResa: string = "DtDReSLI";
    public static dateFinResa: string = "DtFReSLI";
    public static duree: string = "DureeSLI";
    public static noteMax: string = "NoMa_SLI";
    public static noteMin: string = "NoMi_SLI";
    public static noteMaxPourcentage: string = "NoMaPSLI";
    public static noteMinPourcentage: string = "NoMiPSLI";
    public static moyenne: string = "Moy__SLI";
    public static moyennePourcentage: string = "MoyP_SLI";
    public static tauxReponse: string = "TRep_SLI";
    public static noteAvant: string = "NoAv_SLI";
    public static reponseAvant: string = "RepAvSLI";
    public static noteApres: string = "NoAp_SLI";
    public static reponseApres: string = "RepApSLI";
  }
}
export module tDOStatistique {
  export class Cols {
    public static nom: string = "NomFaSTA";
    public static prenom: string = "PrenoSTA";
    public static datePremiereConn: string = "DtDELSTA";
    public static dateDerniereConn: string = "DtFELSTA";
    public static tempsConn: string = "TmpCoSTA";
    public static titreChapitre: string = "ChapiSTA";
    public static description: string = "DescrSTA";
    public static volumeDeclare: string = "VolDeSTA";
    public static titreResa: string = "TResaSTA";
    public static infos: string = "InfosSTA";
    public static dateDebutResa: string = "DtDReSTA";
    public static dateFinResa: string = "DtFReSTA";
    public static duree: string = "DureeSTA";
    public static GrNomSTA: string = "GrNomSTA";
    public static IntitSTA: string = "IntitSTA";
    public static NMaQPSTA: string = "NMaQPSTA";
    public static NMiQPSTA: string = "NMiQPSTA";
    public static NMoQPSTA: string = "NMoQPSTA";
    public static NoMaPSTA: string = "NoMaPSTA";
    public static NoMaQSTA: string = "NoMaQSTA";
    public static NoMaxSTA: string = "NoMaxSTA";
    public static NoMinSTA: string = "NoMinSTA";
    public static NoMiPSTA: string = "NoMiPSTA";
    public static NoMiQSTA: string = "NoMiQSTA";
    public static NoMoPSTA: string = "NoMoPSTA";
    public static NoMoQSTA: string = "NoMoQSTA";
    public static NoMoySTA: string = "NoMoySTA";
    public static NoPasSTA: string = "NoPasSTA";
    public static NoPaQSTA: string = "NoPaQSTA";
    public static NotApSTA: string = "NotApSTA";
    public static Note_STA: string = "Note_STA";
    public static NoteLSTA: string = "NoteLSTA";
    public static NotLQSTA: string = "NotLQSTA";
    public static Rep__STA: string = "Rep__STA";
    public static RepApSTA: string = "RepApSTA";
    public static TitreSTA: string = "TitreSTA";
    public static TRep_STA: string = "TRep_STA";
    public static Type_STA: string = "Type_STA";
  }
}
export module TDOTag {
  export class Cols {
    public static intIdent: string = "Ident";
    public static tagName: string = "tag__TAG";
    public static categorie: string = "CategTAG";
  }
}
export module TUser {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strName: string = "Name_USE";
    public static strDisplay: string = "DisplUSE";
    public static bolMinimize: string = "MinimUSE";
    public static bolCallBack: string = "CallbUSE";
    public static bolDegrade: string = "DegraUSE";
    public static bolNotiEmail: string = "EmailUSE";
    public static bolNotiSms: string = "nosmsUSE";
    public static bolNotiQueoval: string = "NotiQUSE";
    public static strAckKey: string = "AckKey";
    public static strSeparatorDecimal: string = "SepdeUSE";
    public static strSeparatorGroupe: string = "SepgrUSE";
    public static strFullDateTime: string = "FuldtUSE";
    public static strLongDate: string = "LdateUSE";
    public static intNombredecimal: string = "NbdecUSE";
    public static strLongTime: string = "LtimeUSE";
    public static strMonthDay: string = "MndayUSE";
    public static strShortDate: string = "SdateUSE";
    public static strShortTime: string = "StimeUSE";
    public static strYearMont: string = "YmothUSE";
    public static strSeparatorDate: string = "SepdtUSE";
    public static strColor: string = "ColorUSE";
    public static intHeureDebut: string = "HdcnxUSE";
    public static intHeureFin: string = "HfcnxUSE";
    public static intWebAutorise: string = "IswebUSE";
    public static strLigneCTI: string = "LiCtiUSE";
    public static strDemarrage: string = "DemarUSE";
    public static strSSOIdent: string = "CassoUSE";
    public static strCulture: string = "CultuUSE";
    public static strUserIdCnx: string = "IdCnxUSE";
    public static strPassword: string = "Pswd_USE";
    public static strEmailGoogle: string = "EmGooUSE";
    public static strIdentGoogle: string = "IdGooUSE";
    public static intGoogleAutorise: string = "IsGooUSE";
    public static strAccessTokenGoogle: string = "AcGooUSE";
    public static strRefreshTokenGoogle: string = "TkGooUSE";
    public static strEmailMicrosoft: string = "EmMs_USE";
    public static intGenererDocServeur: string = "DocSrUSE";
    public static strCSSUtilisateur: string = "CSS__USE";
    public static strGoogleSecurityLevel: string = "SecLvUSE";
    public static strGoogleCalendarRendezVous: string = "RdvGoUSE";
    public static strGoogleCalendarTaches: string = "TacGoUSE";
    public static strGoogleCalendarActionCo: string = "ActGoUSE";
    public static strGoogleCalendarReservations: string = "RevGoUSE";
    public static strChangeLog: string = "ChgLgUSE";
    public static dtRecoveryMail: string = "DtRecUSE";
  }
}
export module TPAGRAPHIQUE {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strAckKey: string = "AckKey";
    public static TitreGraphe: string = "TitreGRA";
    public static TypeGraphe: string = "Type_GRA";
    public static TypePie: string = "PieTyGRA";
    public static DonutsLabel: string = "LbPieGRA";
    public static LabelType: string = "LbTypGRA";
    public static iscornered: string = "ArronGRA";
    public static ShowLabel: string = "LbShoGRA";
    public static LabelX: string = "LbX__GRA";
    public static LabelY: string = "LbY__GRA";
    public static Regroupement: string = "RegrpGRA";
    public static LabelRotation: string = "LbRotGRA";
    public static Legend: string = "Leg__GRA";
    public static ShowValue: string = "ShoVaGRA";
    public static ReduireNbXLabeL: string = "LbNbRGRA";
    public static Couleur: string = "ColorGRA";
    public static NomChart: string = "IdNomGRA";
    public static Height: string = "Haut_GRA";
    public static Width: string = "LargeGRA";
  }
}
export module TPAPrix {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intCatalogue: string = "CatalPRI";
    public static intCategorie: string = "CategPRI";
    public static intProduit: string = "ProduPRI";
    public static intFournisseur: string = "FournPRI";
    public static monMontant: string = "MontaPRI";
    public static dateMaj: string = "Date_PRI";
    public static intSite: string = "Site_PRI";
    public static monPrixMini: string = "PrimiPRI";
    public static monPrixMaxi: string = "PrimaPRI";
    public static bolRuptureStock: string = "RuptuPRI";
    public static strCodeFournisseur: string = "CoFouPRI";
  }
}
export module TPAApe {
  export class Cols {

  }
}
export module TPAModele {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCode: string = "Code_MOD";
    public static strInfo: string = "Info_MOD";
    public static strAckKey: string = "AckKey";
    public static strZstring: string = "ZstriMOD";
    public static strZstring1: string = "Zstr1MOD";
    public static strZstring2: string = "Zstr2MOD";
    public static strZstring3: string = "Zstr3MOD";
    public static strZstring4: string = "Zstr4MOD";
    public static strGroupe: string = "GroupMOD";
  }
}
export module TPAApplication {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCode: string = "Code_APL";
    public static strType: string = "Type_APL";
    public static strInfo: string = "Info_APL";
    public static strAckKey: string = "AckKey";
    public static datZdate: string = "ZdateAPL";
    public static intZinteger: string = "Zint_APL";
    public static strZstring: string = "ZstriAPL";
    public static decZdecimal: string = "ZdeciAPL";
    public static strGroupe: string = "GroupAPL";
    public static intOrder: string = "OrdreAPL";
  }
}
export module TPABareme {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCode: string = "Code_BAR";
    public static strType: string = "Type_BAR";
    public static strInfo: string = "Info_BAR";
    public static strAckKey: string = "AckKey";
    public static datZdate: string = "ZdateBAR";
    public static intZinteger: string = "Zint_BAR";
    public static strZstring: string = "ZstriBAR";
    public static decZdecimal: string = "ZdeciBAR";
    public static strGroupe: string = "GroupBAR";
    public static strPlage: string = "PlageBAR";
  }
}
export module TPAColumn {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNom: string = "Name_PAC";
    public static strType: string = "Type_PAC";
    public static intTaille: string = "TaillPAC";
    public static strInfo: string = "Info_PAC";
    public static strCode: string = "Code_PAC";
  }
}
export module TPADossier {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intUser: string = "IdusePAD";
    public static intBO: string = "IdBO_PAD";
    public static strValue: string = "ValuePAD";
    public static strInfo: string = "Info_PAD";
  }
}
export module TPAIdentUnique {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCode: string = "Code_IDE";
    public static intIdentUnique: string = "IdentIDE";
    public static strInfo: string = "Info_IDE";
  }
}
export module TPAInsee {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCodePostal: string = "CodpoINS";
    public static strCodeCommune: string = "CodcoINS";
    public static strVille: string = "TitreINS";
  }
}
export module TPANoti {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strUtilisateurs: string = "AceskPAN";
    public static strMode: string = "Mode_PAN";
    public static strCodeIdent: string = "Code_PAN";
    public static strTitre: string = "TitrePAN";
    public static strInfo: string = "Info_PAN";
    public static strPriorite: string = "PriorPAN";
    public static strAcKkey: string = "AckKey";
    public static strOrigine: string = "OrigiPAN";
  }
}
export module TPANumering {
  export class Cols {
    public static intIdent: string = "Ident";
    public static ackKey: string = "ackKey";
    public static strCode: string = "Code_NUM";
    public static lngValeurMin: string = "NuminNUM";
    public static lngValeurMax: string = "NumaxNUM";
    public static lngValeurCurent: string = "NucurNUM";
    public static strInformations: string = "InfosNUM";
  }
}
export module TPAPlanFactureResultat {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strTauxTVA: string = "TxTVACOM";
    public static strNumreoCompte: string = "NumcoCOM";
    public static strNumeroCompteTva: string = "NumtvCOM";
    public static strTypeTVA: string = "TypetCOM";
    public static strInfo: string = "Info_COM";
  }
}
export module TPAPlanFacture {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCode: string = "Code_PLA";
    public static strBO: string = "Bo___PLA";
    public static strCondition: string = "CondiPLA";
    public static strResultat: string = "CodeRPLA";
  }
}
export module TPAArticleFact {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCode: string = "Code_ART";
    public static strInformation: string = "Info_ART";
    public static strDebours: string = "DebouART";
    public static strExclureBPF: string = "ExcbpART";
  }
}
export module tPAParndf {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNature: string = "NaturPNF";
    public static strCompte: string = "ComptPNF";
    public static strTauxTVA: string = "txtvaPNF";
    public static bolModifTauxTVA: string = "MdftxPNF";
    public static strTypeTVA: string = "TytvaPNF";
    public static bomModifTypeTVA: string = "MdtypPNF";
    public static strPrixUnitaire: string = "PrixuPNF";
    public static bolModifPrixUnit: string = "MdpriPNF";
    public static strEntete: string = "EnLibPNF";
  }
}
export module tPAInfoNDF {
  export class Cols {
    public static intIdent: string = "Ident";
  }
}
export module TPAProcedure {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strProcedure: string = "cPcd_PCD";
    public static strProcessus: string = "cPcs_PCD";
    public static strModeOperatoire: string = "cMoOpPCD";
    public static strTexte: string = "textePCD";
    public static strPath: string = "Path_PCD";
    public static strVersion: string = "Vers_PCD";
    public static datDate: string = "Date_PCD";
    public static strAcKkey: string = "AckKey";
  }
}
export module TPAService {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strAssembly: string = "AsblySER";
    public static strClass: string = "classSER";
    public static strMethod: string = "MthodSER";
    public static strParams: string = "ParamSER";
    public static strAccessKey: string = "AckKey";
    public static strTitleService: string = "TitreSER";
    public static strIdentService: string = "IdentSER";
    public static bolActivService: string = "ActivSER";
    public static bolActivTmSpecClient: string = "ActTmSER";
  }
}
export module TPATable {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNom: string = "Name_PAT";
    public static strGroupe: string = "GroupPAT";
    public static strInfo: string = "Info_PAT";
    public static strCode: string = "Code_PAT";
  }
}
export module TTempsPasse {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intUser: string = "IduseTPS";
    public static intDonnee: string = "IddonTPS";
    public static lngTime: string = "Time_TPS";
    public static datDate: string = "Date_TPS";
  }
}
export module TPAWorkFlo {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCodeIdent: string = "Code_PAW";
    public static strMode: string = "Mode_PAW";
    public static strAction: string = "ActioPAW";
    public static intPreload: string = "PreloPAW";
    public static intDesactive: string = "ActivPAW";
    public static strInfo: string = "Info_PAW";
    public static strCode: string = "IdentPAW";
    public static intOrder: string = "OrderPAW";
    public static Param: string = "paramPAW";
    public static Async: string = "asyncPAW";
  }
}
export module TAffiche {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdUser: string = "IduseUSA";
    public static intIdBrick: string = "IdbriUSA";
    public static strColHidden: string = "HidenUSA";
    public static strColWidth: string = "WidthUSA";
  }
}
export module TUSAlerte {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdFrom: string = "IdfrmALE";
    public static intIdTo: string = "Idto_ALE";
    public static intIdPere: string = "IdBO_ALE";
    public static strInfo: string = "Info_ALE";
    public static datDateCreat: string = "DatecALE";
    public static datActivation: string = "DateaALE";
    public static datlecture: string = "DatelALE";
  }
}
export module TBlock {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCode: string = "Code_BLO";
    public static strNom: string = "Name_BLO";
    public static intOrdre: string = "OrdreBLO";
    public static strType: string = "Type_BLO";
    public static strInfo: string = "Info_BLO";
    public static strParam: string = "ParamBLO";
    public static strTriColonne: string = "TricoBLO";
    public static strCodeIdent: string = "CidenBLO";
    public static strAckKey: string = "AckKey";
  }
}
export module TBrick {
  export class Cols {
    public static intIdent: string = "Ident";
    public static IntOrdre: string = "OrdreBRI";
    public static strName: string = "Name_BRI";
    public static strImage: string = "ImageBRI";
    public static strInfo: string = "Info_BRI";
    public static strCodeLanceur: string = "CodlaBRI";
    public static strPage: string = "Page_BRI";
    public static strCodeIdent: string = "CidenBRI";
    public static strAckKey: string = "AckKey";
    public static intLanceur: string = "LunchBRI";
    public static strParametre: string = "ParamBRI";
  }
}
export module TConteneur {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCodelanceur: string = "CodlaCON";
    public static strNom: string = "Name_CON";
    public static strCodeIdent: string = "CidenCON";
    public static intOrdre: string = "OrdreCON";
  }
}
export module TUSFiltre {
  export class Cols {
    public static intIdent: string = "Ident";
    public static sctAckKey: string = "AckKey";
    public static intUser: string = "IduseFIL";
    public static strCode: string = "Code_FIL";
    public static strInfo: string = "Info_FIL";
    public static strCol01: string = "Col01FIL";
    public static strCol02: string = "Col02FIL";
    public static strCol03: string = "Col03FIL";
    public static strCol04: string = "Col04FIL";
    public static strCol05: string = "Col05FIL";
    public static strCol06: string = "Col06FIL";
    public static strCol07: string = "Col07FIL";
    public static strCol08: string = "Col08FIL";
    public static strCol09: string = "Col09FIL";
    public static strCol10: string = "Col10FIL";
  }
}
export module TGroupe {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strName: string = "TitreGRP";
    public static strTrigramme: string = "TrigrGRP";
  }
}
export module TLanceur {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strPage: string = "Page_LAN";
    public static strNom: string = "Name_LAN";
    public static strCode: string = "Code_LAN";
    public static strDisplay: string = "DisplLAN";
    public static strOrdre: string = "OrdreLAN";
    public static strImage: string = "ImageLAN";
    public static strParametre: string = "ParamLAN";
    public static strInfo: string = "Info_LAN";
    public static strCodeIdent: string = "CidenLAN";
    public static strAckKey: string = "AckKey";
  }
}
export module TUSNoti {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdFrom: string = "IdfrmNOT";
    public static intIdTo: string = "Idto_NOT";
    public static intIdBO: string = "IdBO_NOT";
    public static strInfo: string = "Info_NOT";
    public static datDateCreat: string = "Date_NOT";
    public static intPriorite: string = "Prio_NOT";
    public static datlecture: string = "LectuNOT";
    public static intIdMethod: string = "IdMtdNOT";
  }
}
export module TPortail {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCodelanceur: string = "CodlaPOR";
    public static strCodeBlock: string = "Code_POR";
    public static strAckKey: string = "AckKey";
    public static strInfo: string = "Info_POR";
    public static strCodeIdent: string = "CidenPOR";
    public static intOrdre: string = "OrdrePOR";
    public static strImage: string = "ImagePOR";
    public static strParam: string = "ParamPOR";
    public static positionLigne: string = "Row__POR";
    public static positionColonne: string = "ColonPOR";
    public static tailleLigne: string = "SizeRPOR";
    public static tailleColonne: string = "SizeCPOR";
    public static afficheDefault: string = "DefauPOR";
  }
}
export module TTreeview {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNom: string = "Name_TRW";
    public static strImage: string = "ImageTRW";
    public static strPage: string = "Page_TRW";
    public static strParam: string = "ParamTRW";
    public static strDisplay: string = "DisplTRW";
    public static intOrdre: string = "OrdreTRW";
    public static strSql: string = "Tsql_TRW";
    public static strCodeIdent: string = "CidenTRW";
  }
}
export module TPAGroupe {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNom: string = "Nom__GRP";
    public static strType: string = "Type_GRP";
    public static strType2: string = "Type2GRP";
    public static strMode: string = "Mode_GRP";
    public static strFiltre: string = "FiltrGRP";
    public static strFiltre2: string = "Filt2GRP";
  }
}
export module TPATraduction {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strCode: string = "Code_TRA";
    public static strFR: string = "FR___TRA";
    public static strValeur: string = "Valeur";
  }
}
export module TPACorrespondance {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strGroupe: string = "groupCOR";
    public static strColonne: string = "ColonCOR";
    public static strInputValue: string = "ValInCOR";
    public static strOutputValue: string = "VaOutCOR";
    public static strAckKey: string = "AckKey";
  }
}
export module TCODossier {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strAccesDossier: string = "AccesDOS";
    public static intProfondeurCpt: string = "ProfoDOS";
    public static strLibelle: string = "LibelDOS";
    public static strCreateur: string = "CreatDOS";
    public static strNomUserModif: string = "ModifDOS";
    public static strNomUserEnCours: string = "User_DOS";
    public static strDernierNumBordereau: string = "NumBoDOS";
    public static strDernierNumFacture: string = "NumFaDOS";
    public static strParamJournaux: string = "ParJxDOS";
    public static strParamComptes: string = "ParCpDOS";
    public static datCreation: string = "DatecDOS";
    public static datModification: string = "DatemDOS";
    public static monEcartLettrage: string = "LetEcDOS";
    public static strListUserNotifier: string = "NotifDOS";
    public static strMoisRHencours: string = "MoiRHDOS";
    public static strListUserRHNotifier: string = "NotRHDOS";
  }
}
export module TCOCompte {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdDossier: string = "IdCltCPT";
    public static bolAutoriseAuxiliaire: string = "CoAuxCPT";
    public static bolIsCompteRevise: string = "RevisCPT";
    public static bolIsNatureAchat: string = "AchatCPT";
    public static bolIsNatureVente: string = "VenteCPT";
    public static bolIsNatureDepense: string = "DepenCPT";
    public static bolIsNatureRecette: string = "RecetCPT";
    public static bolIsNatureTVA: string = "TvaOnCPT";
    public static strLibelle: string = "LibelCPT";
    public static strLibelleCodeVirt: string = "Libelle_Code_CPTvirtuel";
    public static strCodeLibelleVirt: string = "Code_Libelle_CPTvirtuel";
    public static strCode: string = "Code_CPT";
    public static strTVA: string = "CoTVACPT";
    public static strContrePartie: string = "ContrCPT";
    public static strComptesAssocies: string = "ListeCPT";
    public static strRacineAuxiliaire: string = "CodAuCPT";
    public static strCodeTypeCompte: string = "CoTypCPT";
    public static strInfosMillesime: string = "MiSoLCPT";
    public static strAdresse1: string = "Adre1CPT";
    public static strAdresse2: string = "Adre2CPT";
    public static strCodePostal: string = "CodCpCPT";
    public static strVille: string = "VilleCPT";
    public static strEmail: string = "EmailCPT";
    public static strSiteWeb: string = "Site_CPT";
    public static strPrenom: string = "PrenoCPT";
    public static strNom: string = "Nom__CPT";
    public static strTelephone: string = "NuTelCPT";
    public static strTVAIntraComm: string = "TVAInCPT";
  }
}
export module TCOJournal {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdDossier: string = "IdCltJOU";
    public static strCode: string = "Code_JOU";
    public static strLibelle: string = "LibelJOU";
    public static strType: string = "Type_JOU";
    public static strContrePartie: string = "CptEqJOU";
    public static strCompteTVA: string = "CpTvaJOU";
    public static strTypeNumPiece: string = "PiNumJOU";
    public static strDernierNumPiece: string = "NuPieJOU";
    public static strTypeLibelle: string = "LibeEJOU";
    public static datCloture: string = "daCloJOU";
  }
}
export module TCOCopilote {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdDossier: string = "IdCltCOP";
    public static strMillesime: string = "MilleCOP";
    public static strCommentaires: string = "Info_COP";
    public static strSaisonnalite: string = "SaisoCOP";
    public static strCAannuel: string = "CAan_COP";
    public static strMCVannuel: string = "MCVanCOP";
    public static strChargesFixes: string = "ChargCOP";
    public static strTypeDonnee: string = "Type_COP";
    public static strCoefSaisonM1: string = "CSM1_COP";
    public static strCoefSaisonM2: string = "CSM2_COP";
    public static strCoefSaisonM3: string = "CSM3_COP";
    public static strCoefSaisonM4: string = "CSM4_COP";
    public static strCoefSaisonM5: string = "CSM5_COP";
    public static strCoefSaisonM6: string = "CSM6_COP";
    public static strCoefSaisonM7: string = "CSM7_COP";
    public static strCoefSaisonM8: string = "CSM8_COP";
    public static strCoefSaisonM9: string = "CSM9_COP";
    public static strCoefSaisonM10: string = "CSM10COP";
    public static strCoefSaisonM11: string = "CSM11COP";
    public static strCoefSaisonM12: string = "CSM12COP";
    public static strChiffreAffaireM1: string = "CAm1_COP";
    public static strChiffreAffaireM2: string = "CAm2_COP";
    public static strChiffreAffaireM3: string = "CAm3_COP";
    public static strChiffreAffaireM4: string = "CAm4_COP";
    public static strChiffreAffaireM5: string = "CAm5_COP";
    public static strChiffreAffaireM6: string = "CAm6_COP";
    public static strChiffreAffaireM7: string = "CAm7_COP";
    public static strChiffreAffaireM8: string = "CAm8_COP";
    public static strChiffreAffaireM9: string = "CAm9_COP";
    public static strChiffreAffaireM10: string = "CAm10COP";
    public static strChiffreAffaireM11: string = "CAm11COP";
    public static strChiffreAffaireM12: string = "CAm12COP";
    public static strChargesM1: string = "CHm1_COP";
    public static strChargesM2: string = "CHm2_COP";
    public static strChargesM3: string = "CHm3_COP";
    public static strChargesM4: string = "CHm4_COP";
    public static strChargesM5: string = "CHm5_COP";
    public static strChargesM6: string = "CHm6_COP";
    public static strChargesM7: string = "CHm7_COP";
    public static strChargesM8: string = "CHm8_COP";
    public static strChargesM9: string = "CHm9_COP";
    public static strChargesM10: string = "CHm10COP";
    public static strChargesM11: string = "CHm11COP";
    public static strChargesM12: string = "CHm12COP";
  }
}
export module TCOExercice {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdDossier: string = "IdCltEXE";
    public static strMillesime: string = "MilleEXE";
    public static strDebut: string = "DateDEXE";
    public static strFin: string = "DateFEXE";
    public static strInfos: string = "CommtEXE";
    public static bolCloture: string = "ClotuEXE";
  }
}
export module TCOEcriture {
  export class Cols {
    public static bolEcritureNonComptable: string = "NoCtaECR";
    public static intIdent: string = "Ident";
    public static intIdDossier: string = "IdCltECR";
    public static intNumEcriture: string = "Num__ECR";
    public static strMillesime: string = "MilleECR";
    public static datDate: string = "DatCrECR";
    public static datDateValeur: string = "RaDatECR";
    public static datDateReleve: string = "ReDatECR";
    public static datDateValidation: string = "VaDatECR";
    public static strLibelle: string = "LibelECR";
    public static monDebit: string = "DebitECR";
    public static monCredit: string = "CrediECR";
    public static monMontantTVA: string = "VaTvaECR";
    public static strIdJournal: string = "JournECR";
    public static strIdCptGeneral: string = "CptGeECR";
    public static strIdCptAuxiliaire: string = "CptAuECR";
    public static strPiece: string = "NumPiECR";
    public static strLettrage: string = "LettrECR";
    public static strInfos: string = "InfosECR";
    public static strReccurence: string = "RecurECR";
    public static strDetails: string = "DetaiECR";
    public static strCompteTVA: string = "CpTvaECR";
    public static strNumBordereau: string = "NuBorECR";
  }
}
export module TCOProfil {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intPriority: string = "LevelPRO";
    public static intIdUser: string = "IdUsePRO";
    public static strLibelle: string = "LibelPRO";
    public static bolIsBlockOpCouranteVisible: string = "VisOpPRO";
    public static bolIsBlockImpressionVisible: string = "VisImPRO";
    public static bolIsBlockOutilsVisible: string = "VisOuPRO";
    public static bolIsBlockParametrageVisible: string = "VisPaPRO";
    public static bolIsBlockTravailDistanceVisible: string = "VisTePRO";
    public static bolIsBlockGestionExpertComptable: string = "VisExPRO";
    public static bolIsReadOnly: string = "Read_PRO";
  }
}
export module TCOAVDR {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdDossier: string = "IdCliPIE";
    public static bolModifiSuiteImport: string = "PointPIE";
    public static bolFacturationRapide: string = "FactuPIE";
    public static bolNumerise: string = "NumerPIE";
    public static bolTraite: string = "Util_PIE";
    public static strCodePiece: string = "Code_PIE";
    public static strLibelle: string = "LibelPIE";
    public static strJournal: string = "JournPIE";
    public static strMillesime: string = "MillePIE";
    public static strFichier: string = "ExtenPIE";
    public static strAuteur: string = "AuteuPIE";
    public static strCommentaire: string = "CommePIE";
    public static strGUIDPiece: string = "Guid_PIE";
    public static strTypeOperation: string = "Type_PIE";
    public static strNumeroChq: string = "NuChqPIE";
    public static strMoyenPayement: string = "TypPaPIE";
    public static monMontantTTC: string = "MtTtcPIE";
    public static monMontantHT: string = "MtHT_PIE";
    public static monMontantTVA: string = "MtTvaPIE";
    public static datDateCreation: string = "DatPiPIE";
    public static datDateValidation: string = "VaDatPIE";
    public static datDateEcheance: string = "DtEchPIE";
    public static Tempo: string = "TempoPIE";
  }
}
export module TCOBanque {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdDossier: string = "IdCltBQE";
    public static strNomBanque: string = "Nom__BQE";
    public static strAdresse1: string = "Adre1BQE";
    public static strAdresse2: string = "Adre2BQE";
    public static strVille: string = "VilleBQE";
    public static strCodePostal: string = "CodepBQE";
    public static strSiteWeb: string = "Site_BQE";
    public static strRIBAgence: string = "NuAgeBQE";
    public static strRIBCompte: string = "NuCptBQE";
    public static strRIBGuichet: string = "NuGuiBQE";
    public static strRIBClef: string = "NuCleBQE";
    public static strCodeCompteAssocie: string = "CodCpBQE";
  }
}
export module TCOProduit {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdDossier: string = "IdCltPDT";
    public static strCode: string = "Code_PDT";
    public static strLibelle: string = "LibelPDT";
    public static strCodeNature: string = "CodNaPDT";
    public static strCodeCatalogue: string = "CodCaPDT";
    public static strCodeTVA: string = "CodTvCPT";
    public static monPrixUnitaire: string = "PxUniPDT";
  }
}
export module tCOParamRH {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdDossier: string = "IdCltRH";
    public static strNomColonne: string = "ColNaRH";
    public static strColNonSupprimable: string = "VerouRH";
    public static strCode: string = "Code_RH";
    public static strLibelle: string = "LibelRH";
    public static strOrdre: string = "OrdreRH";
    public static strValeurDefaut: string = "DefauRH";
    public static strRAZdonnees: string = "RAZ__RH";
    public static strIsSelected: string = "SelecRH";
  }
}
export module tCORHpaye {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strAcKkey: string = "AckKey";
    public static intIdDossier: string = "IdCltRHP";
    public static strMois: string = "Mois_RHP";
    public static strNom: string = "Nom__RHP";
    public static strPrenom: string = "PrenoRHP";
    public static strNomMarital: string = "NomMaRHP";
  }
}
export module tCOHistoRHpaye {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strAcKkey: string = "AckKey";
    public static intIdDossier: string = "IdCltRHP";
    public static strDateValidation: string = "VaDatRHP";
    public static strMois: string = "Mois_RHP";
    public static strNom: string = "Nom__RHP";
    public static strPrenom: string = "PrenoRHP";
    public static strNomMarital: string = "NomMaRHP";
  }
}
export module tCODocument {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intIdDossier: string = "IdCliDOC";
    public static strTitre: string = "TitreDOC";
    public static strCategorie: string = "CategDOC";
    public static datDatePublication: string = "DatPuDOC";
    public static datDatePiece: string = "DatPiDOC";
    public static strMillesime: string = "MilleDOC";
    public static strTypeDoc: string = "Type_DOC";
    public static strFichier: string = "ExtenDOC";
    public static Tempo: string = "TempoDOC";
  }
}
export module tCORapprochement {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strAcKkey: string = "AckKey";
    public static intIdDossier: string = "IdCltRAP";
    public static strDate: string = "Date_RAP";
    public static strDebit: string = "DebitRAP";
    public static strCredit: string = "CrediRAP";
  }
}
export module tDOHistoriqueLigne {
  export class Cols {
    public static intIdent: string = "Ident";
    public static intFrom: string = "IdfrmHIS";
    public static strDate: string = "Date_HIS";
    public static strOldValue: string = "OldvaHIS";
    public static strNewValue: string = "NewvaHIS";
    public static intWhat: string = "IdqoiHIS";
  }
}
export module tDOGroupe {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strInfo: string = "Info_GRP";
  }
}
export module tDOProduit {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strDesignation: string = "DesigPDT";
    public static intChefProjet: string = "IdProPDT";
    public static strExcNotif: string = "Exit_PDT";
    public static datRenouvellement: string = "DtrenPDT";
    public static datProcessTermine: string = "DtterPDT";
    public static strNomDeclareAnvisa: string = "nomavPDT";
    public static strRefProduit: string = "NommoPDT";
    public static strModeleRef: string = "MorefPDT";
    public static strSecteurProduit: string = "CatclPDT";
    public static strCategorieProcess: string = "CatPrPDT";
    public static datParutionJO: string = "DtpjoPDT";
    public static strNumeroEnregistrementANVISA: string = "NuenrPDT";
    public static strNumeroInterne: string = "NuminPDT";
    public static datArchivage: string = "DlarcPDT";
    public static datProrogation: string = "DlproPDT";
    public static datExigence: string = "DlexiPDT";
    public static datControle: string = "DlCtlPDT";
    public static strNomTechnique: string = "NomtcPDT";
    public static strCodeTechnique: string = "CodtcPDT";
  }
}
export module tDOProtocole {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strDesignation: string = "DesigPTE";
    public static datCreation: string = "DtcrePTE";
    public static datRenouvellement: string = "DtExpPTE";
    public static strExcNotif: string = "Exit_PTE";
  }
}
export module tPAColis {
  export class Cols {
    public static intIdent: string = "Ident";
    public static strNumLicence: string = "NuLicCLS";
    public static strNumTaxeDouane: string = "NuDouCLS";
    public static strDescription: string = "DesDoCLS";
    public static strQuantite: string = "QuantCLS";
    public static intIdColis: string = "IdColCLS";
    public static intIdDistributeur: string = "IdDisCLS";
    public static intIdProduit: string = "IdProCLS";
    public static datDateEnvoi: string = "DtEnvCLS";
    public static strNumEnregisProduit: string = "NuenrCLS";
  }
}
